import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCoins, faCalculator, faGift, faChevronDown, faChevronUp,
  faUser, faStore, faTag, faBox, faHashtag, faDollarSign,
  faPlay, faCheck, faTimes, faSpinner, faArrowLeft,
  faRupeeSign,faSearch,faToggleOn, faToggleOff,faShoppingCart, 
  faRemove
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate,useLocation } from 'react-router-dom';
import '../../Css/Tooltip.css';
import { decryptData } from '../../../utils/storageCrypto'; 
// Function to generate ObjectId-like string
const generateObjectId = () => {
  const timestamp = Math.floor(Date.now() / 1000).toString(16);
  const randomBytes = Array.from({ length: 16 }, () => 
    Math.floor(Math.random() * 256).toString(16).padStart(2, '0')
  ).join('').substring(0, 16);
  return timestamp + randomBytes;
};


// Add this constant at the top of the file, after the imports
const DUMMY_CUSTOMER = {
  _id: '507f1f77bcf86cd799439011',
  customer_name: 'Dummy Customer',
  customer_type: 'Builder'
};

const RewardRulesSimulator = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const  selectedRuleData  = location.state.Rule || [];
  console.log("location",location.state);
  console.log('Selected rule data:', selectedRuleData);
  const [activeComponent, setActiveComponent] = useState('reward-coins');
  const [isLoading, setIsLoading] = useState(false);
  
  // Common data states
  const [customers, setCustomers] = useState([]);
  const [partners, setPartners] = useState([]);
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);  
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [selectedPartnerIds, setSelectedPatnerIds] = useState([]);

  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const backendApiUrl2 = process.env.REACT_APP_FORE_BRICKBUCKET;
  
  useEffect(() => {
    fetchInitialData();
  }, []);

    // Fetch items when categories are selected
  useEffect(() => {
    if (selectedCategoryIds.length > 0 && selectedPartnerIds.length > 0) {
      const encryptedToken = sessionStorage.getItem('token');
          const token = decryptData(encryptedToken);
      const encryptedorganizationId = sessionStorage.getItem('organizationId');
      const organizationId = decryptData(encryptedorganizationId);
      fetchItems(token, selectedCategoryIds,selectedPartnerIds,organizationId);
    } else {
      // If no categories selected, fetch all items or clear items
      setItems([]);
    }
  }, [selectedCategoryIds,selectedPartnerIds]);

  const fetchInitialData = async () => {
    setIsLoading(true);
    try {
      const encryptedToken = sessionStorage.getItem('token');
          const token = decryptData(encryptedToken);
      
      // Fetch customers, partners, categories, and items
      await Promise.all([
        fetchCustomers(token),
        fetchPartners(token),
        fetchCategories(token),
        //fetchItems(token)
      ]);
    } catch (error) {
      console.error('Error fetching initial data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCustomers = async (token) => {
    try {
      const response = await fetch(`${backendApiUrl}customer/get-all-customers`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      const data = await response.json();
      console.log('Fetched customers:', data);
      if (data?.data) setCustomers(data.data);
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  const fetchPartners = async (token) => {
    try {
      const response = await fetch(`${backendApiUrl}vendor/get-all-vendors`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      const data = await response.json();
      console.log('Fetched partners:', data);
      if (data?.data) setPartners(data.data);
    } catch (error) {
      console.error('Error fetching partners:', error);
    }
  };

  const fetchCategories = async (token) => {
    try {
      const response = await fetch(`${backendApiUrl}product-category/get-all-productCategories`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      const data = await response.json();
      console.log('Fetched categories:', data);
      if (data?.data) setCategories(data.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };


/*   const fetchItems = async (token, categoryIds = []) => {
    console.log('Fetching items for categories:', categoryIds);
    try {
      const response = await fetch(`${backendApiUrl}product/get-products-by-category-ids`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify({
          categoryIds: categoryIds
        })
      });
      const data = await response.json();
      console.log('Fetched items:', data);
      if (data?.data) setItems(data.data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  }; */

  const fetchItems = async (token, categoryIds = [],partnerIds = [],organizationId) => {
    console.log('Fetching items for categories:', categoryIds);
    try {
          // Join the arrays into comma-separated strings
    const vendorIdsString = partnerIds.join(','); // Convert partnerIds array to a string
    const categoryIdsString = categoryIds.join(','); // Convert categoryIds array to a string
      const response = await fetch(`${backendApiUrl}product/get-products-by-vendors-and-categories?vendor_ids=${vendorIdsString}&category_ids=${categoryIdsString}&organizationId=${organizationId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      const data = await response.json();
      console.log('Fetched items:', data);
      if (data?.data) setItems(data?.data?.products);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  const fetchRewardRules = async () => {
    const encryptedToken = sessionStorage.getItem('token');
        const token = decryptData(encryptedToken);
    try {
      const response = await fetch(backendApiUrl + "rules/all", {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        
      });
      const data = await response.json();
      console.log('Fetched reward rules:', data);

      // Return the actual data instead of just logging it
    return data?.data || data || []; // Adjust based on your API response structure

    } catch (error) {
      console.error('Error fetching reward rules:', error);
    }
  };


  const handleBackToRules = () => {
    navigate('/bb/app/rewardrules/rewardruleslist');
  };

   // Function to handle category selection changes
  const handleCategoryChange = (selectedIds) => {
    setSelectedCategoryIds(selectedIds);
  };

  const handlePartnerChange = (selectedPartnerIds) => {
  // You can use these IDs to refetch items, update filters, etc.
  console.log("Selected Partner IDs:", selectedPartnerIds);
    setSelectedPatnerIds(selectedPartnerIds)
  // Optionally trigger API to refetch items by vendors
};


  function calculateRewardAmount(context, rewardRule) {
  const { type, value, apply, limit, limitType } = rewardRule.reward;
  let totalAmount = 0;

  console.log('Calculating reward for rule:', rewardRule.name);
  console.log('Reward config:', rewardRule.reward);
  console.log('Context items:', context.items);

  // If no apply field or empty, default to order amount
  if (!apply || apply.length === 0) {
    const orderAmount = getFieldValue(context, 'order.amount') || 
                        getFieldValue(context, 'totalAmount') ||
                       getFieldValue(context, 'amount') || 
                       getFieldValue(context, 'total') || 0;
    
    console.log('No apply field, using order amount:', orderAmount);
    
   if (type === 'percentage') {
      totalAmount = orderAmount * (value / 100);
    } else if (type === 'fixed') {
      totalAmount = value;
    }
    
    // APPLY LIMIT HERE
    if (limit && orderAmount > 0) {
      if (limitType && limitType === 'percentage') {
        const maxAllowed = orderAmount * (limit / 100);
        console.log(`Calculated amount: ${totalAmount}, Max allowed (${limit}%): ${maxAllowed}`);
        totalAmount = Math.min(totalAmount, maxAllowed);
        console.log(`Final amount after limit: ${totalAmount}`);
      } else if (limitType && limitType === 'fixed') {
        const maxAllowed = limit;
        console.log(`Calculated amount: ${totalAmount}, Max allowed (${limit}): ${maxAllowed}`);
        totalAmount = Math.min(totalAmount, maxAllowed);
        console.log(`Final amount after limit: ${totalAmount}`);
      }
    }
    
    return totalAmount;
  }

  // Process each apply condition
  for (const applyCondition of apply) {
    console.log('Processing apply condition:', applyCondition);
    
    if (applyCondition === 'order') {
      // Use order amount
      const orderAmount = getFieldValue(context, 'order.amount') || 
                          getFieldValue(context, 'totalAmount') ||    
                         getFieldValue(context, 'amount') || 
                         getFieldValue(context, 'total') || 0;
      
      console.log('Order amount found:', orderAmount);
      
      if (type === 'percentage') {
        totalAmount += orderAmount * (value / 100);
      } else if (type === 'fixed') {
        totalAmount += value;
      }
    } 
    else if (applyCondition === 'item' || applyCondition === 'items') {
      // Use individual item prices
      const items = getFieldValue(context, 'items') || 
                   getFieldValue(context, 'order.items') || 
                   getFieldValue(context, 'products') || [];
      
      console.log('Items found:', items);
      
      if (Array.isArray(items)) {
        for (const item of items) {
          const itemPrice = Number(item.price) || Number(item.amount) || Number(item.value) || Number(item.cost) || 0;
          console.log(`Item: ${item.name}, Price: ${itemPrice}`);
          
          if (type === 'percentage') {
            const itemReward = itemPrice * (value / 100);
            totalAmount += itemReward;
            console.log(`Item reward: ${itemReward}`);
          } else if (type === 'fixed') {
            totalAmount += value; // Fixed amount per item
          }
        }
      }
    }
    else {
      // Treat as specific field path or category name
      const fieldValue = getFieldValue(context, applyCondition);
      
      if (fieldValue !== undefined) {
        if (type === 'percentage') {
          totalAmount += Number(fieldValue) * (value / 100);
        } else if (type === 'fixed') {
          totalAmount += value;
        }
      } else {
        // Check if it's a category name in items
        const items = getFieldValue(context, 'items') || 
                     getFieldValue(context, 'order.items') || 
                     getFieldValue(context, 'products') || [];
        
        if (Array.isArray(items)) {
          for (const item of items) {
            const itemCategory = item.category || item.type || '';
            if (itemCategory.toLowerCase() === applyCondition.toLowerCase()) {
              const itemPrice = Number(item.price) || Number(item.amount) || Number(item.value) || Number(item.cost) || 0;
              
              if (type === 'percentage') {
                totalAmount += itemPrice * (value / 100);
              } else if (type === 'fixed') {
                totalAmount += value;
              }
            }
          }
        }
      }
    }
  }

  // FIXED: Apply limit based on limitType
  if (limit) {
    const baseAmount = getFieldValue(context, 'totalAmount') || 
                      getFieldValue(context, 'order.amount') || 
                      getFieldValue(context, 'amount') || 0;
    
    if (baseAmount > 0) {
      let maxAllowed;
      
      if (limitType && limitType === 'percentage') {
        // Use limit as percentage of base amount
        maxAllowed = baseAmount * (limit / 100);
        console.log(`Total calculated: ${totalAmount}, Max allowed (${limit}% of ${baseAmount}): ${maxAllowed}`);
      } else if (limitType && limitType === 'fixed') {
        // Use limit as fixed amount
        maxAllowed = limit;
        console.log(`Total calculated: ${totalAmount}, Max allowed (fixed ${limit}): ${maxAllowed}`);
      } else {
        // Default to percentage if limitType is not specified
        maxAllowed = baseAmount * (limit / 100);
        console.log(`Total calculated: ${totalAmount}, Max allowed (default ${limit}% of ${baseAmount}): ${maxAllowed}`);
      }
      
      totalAmount = Math.min(totalAmount, maxAllowed);
      console.log(`Final amount after ${limitType || 'percentage'} limit: ${totalAmount}`);
    }
  }

  console.log('Total calculated amount:', totalAmount);
  return totalAmount;
}

function calculateExpiryDate(expiryRules) {
  if (!expiryRules || expiryRules.length === 0) {
    // Default to 90 days from now
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 90);
    return expiryDate;
  }

  const expiryRule = expiryRules[0]; // Take first expiry rule
  const expiryConfig = expiryRule.expiry;
  
  if (expiryConfig) {
    const expiryDate = new Date();
    
    switch (expiryConfig.type) {
      case 'days':
        expiryDate.setDate(expiryDate.getDate() + expiryConfig.value);
        break;
      case 'months':
        expiryDate.setMonth(expiryDate.getMonth() + expiryConfig.value);
        break;
      case 'years':
        expiryDate.setFullYear(expiryDate.getFullYear() + expiryConfig.value);
        break;
      default:
        expiryDate.setDate(expiryDate.getDate() + (expiryConfig.value || 90));
    }
    
    return expiryDate;
  }

  // Fallback to 90 days
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 90);
  return expiryDate;
}


const createEligibleAt = (context, partnerId) => {
  const conditions = [];
  
  // Add conditions for each relevant field in context
  Object.keys(context).forEach(key => {
    if (['category', 'brand', 'product_type', 'is_ecommerce', 'partner_id'].includes(key)) {
      conditions.push({
        field: key,
        operator: '==',
        value: context[key]
      });
    }
  });
  
  // If no specific conditions, create a default condition
  if (conditions.length === 0) {
    conditions.push({
      field: 'partner_id',
      operator: '==',
      value: partnerId
    });
  }
  
  return conditions;
};


const createRedemptionCaps = (redemptionRules, context) => {
  if (!redemptionRules || !Array.isArray(redemptionRules) || redemptionRules.length === 0) {
    return [{
      redeem: {
        type: 'percentage',
        value: 100,
        apply: ['order']
      }
    }];
  }

  return redemptionRules.map(rule => ({
    redeem: {
      type: rule.redeem?.type || 'percentage',
      value: rule.redeem?.value || 100,
      apply: rule.redeem?.apply || ['order'],
      limit: rule.redeem?.limit || null,
      limitType: rule.redeem?.limitType || 'fixed'
    }
  }));
};

const createExpiryArray = (expiryRules, context) => {
  if (!expiryRules || !Array.isArray(expiryRules) || expiryRules.length === 0) {
    return [{
      type: 'days',
      value: 30,
      conditions: [{
        field: 'default',
        operator: '==',
        value: true
      }]
    }];
  }

  return expiryRules.map(rule => ({
    type: rule.expiry?.type || 'days',
    value: rule.expiry?.value || 30,
    conditions: rule.conditions || [{
      field: 'default',
      operator: '==',
      value: true
    }]
  }));
};

function determineRewardApplication(applyTargets) {
  if (!Array.isArray(applyTargets)) {
    return { immediate: false, source: 'wallet', destination: 'wallet' };
  }

  const immediate = applyTargets.some(target => 
    ['currentOrder', 'order', 'immediate'].includes(target)
  );

  let source = 'wallet';
  let destination = 'wallet';

  // Priority order for source determination
  if (applyTargets.includes('order') || applyTargets.includes('currentOrder')) {
    source = 'order';
    destination = 'order';
  } else if (applyTargets.includes('promise')) {
    source = 'promise';
    destination = 'wallet';
  } else if (applyTargets.includes('wallet')) {
    source = 'wallet';
    destination = 'wallet';
  }

  return { immediate, source, destination };
}

// Helper function to get field value from context (reuse existing function)
function getFieldValue(context, field) {
  if (!context || !field) return undefined;
  
  const value = field.split('.').reduce((obj, key) => obj && obj[key], context);
  
  // For specific fields that are arrays, you might want to return the first item
  // or handle them differently based on your business logic
  if (field === 'category' && Array.isArray(value) && value.length > 0) {
    return value[0]; // Return first category
  }
  
  if (field === 'brand' && Array.isArray(value) && value.length > 0) {
    return value[0]; // Return first brand
  }
  
  return value;
}


// Helper function to match conditions 
function matchesCondition(contextValue, conditionValue, operator) {
  // Convert string numbers to numbers for comparison
  if (!isNaN(contextValue) && !isNaN(conditionValue)) {
    contextValue = Number(contextValue);
    conditionValue = Number(conditionValue);
  }
  
  // Convert to string for text comparison
  const contextStr = String(contextValue).toLowerCase();
  const conditionStr = String(conditionValue).toLowerCase();
  
  switch (operator) {
    case '==':
    case 'equals':
      return contextStr === conditionStr;
    case '!=':
      return contextStr !== conditionStr;
    case '>':
      return Number(contextValue) > Number(conditionValue);
    case '>=':
      return Number(contextValue) >= Number(conditionValue);
    case '<':
      return Number(contextValue) < Number(conditionValue);
    case '<=':
      return Number(contextValue) <= Number(conditionValue);
    case 'in':
      if (Array.isArray(conditionValue)) {
        return conditionValue.some(val => String(val).toLowerCase() === contextStr);
      }
      return conditionStr.includes(contextStr);
    case 'contains':
      return contextStr.includes(conditionStr);
    default:
      return contextStr === conditionStr;
  }
}




const removeDuplicatesAndRecalculateWallet = async (consumer_id) => {
  const wallet = await sessionStorage.getItem("buildcoinsWallet").findOne({ consumer_id });

  if (!wallet) {
    throw new Error('Wallet not found');
  }

  // Remove duplicate transaction IDs
  const uniqueTransactionIds = [...new Set(wallet.transactions.map(id => id.toString()))];

  // Fetch all relevant transactions
  const transactions = await sessionStorage.getItem("coinLedger").find({ _id: { $in: uniqueTransactionIds } });

  // Recalculate coins
  let totalCredit = 0;
  let totalDebit = 0;

  for (const tx of transactions) {
    if (tx.transaction_type === 'credit') totalCredit += tx.build_coins;
    if (tx.transaction_type === 'debit') totalDebit += tx.build_coins;
  }

  const available = totalCredit - totalDebit;
  const locked = Math.max(0, available);

  // Update wallet
  wallet.transactions = uniqueTransactionIds;
  wallet.earned_coins = totalCredit;
  wallet.redeemed_coins = totalDebit;
  wallet.available_coins = available;
  wallet.locked_coins = locked;

  await wallet.save();
};


const findWalletInSession = (consumerId) => {
  try {
    const walletsData = sessionStorage.getItem('buildcoinsWallet');
    if (!walletsData) return null;
    
    // If storing single wallet
    const wallet = JSON.parse(walletsData);
    if (wallet.consumer_id === consumerId) {
      return wallet;
    }
    
    // If storing array of wallets
    const wallets = JSON.parse(walletsData);
    if (Array.isArray(wallets)) {
      return wallets.find(w => w.consumer_id === consumerId);
    }
    
    return null;
  } catch (error) {
    console.error('Error finding wallet in session:', error);
    return null;
  }
};



const calculateRewardCoinsBasedOnRules = async (context) => {
  try {
    console.log('=== Starting calculateRewardCoinsBasedOnRules ===');
    console.log('Context received:', JSON.stringify(context, null, 2));

    let rewardPrograms;
    if(selectedRuleData.length > 0){
      rewardPrograms = selectedRuleData;
      console.log('using Selected rule data:', rewardPrograms);
    }
    else{
    // Get all reward programs
    rewardPrograms = await fetchRewardRules();
  }
    console.log(`Found ${rewardPrograms.length} reward programs`);
    
    if (!rewardPrograms.length) {
      return {
        success: false,
        message: 'No reward programs found',
        data: { rewards: [], total_coins: 0 }
      };
    }

    const matchedRewards = [];
    
    // FIXED: Get existing data from session storage instead of overwriting
    const getExistingEligibilities = () => {
      try {
        const existing = sessionStorage.getItem('Eligibility');
        return existing ? JSON.parse(existing) : [];
      } catch (error) {
        console.error('Error parsing existing eligibilities:', error);
        return [];
      }
    };

    const getExistingCoinLedgers = () => {
      try {
        const existing = sessionStorage.getItem('coinLedger');
        return existing ? JSON.parse(existing) : [];
      } catch (error) {
        console.error('Error parsing existing coin ledgers:', error);
        return [];
      }
    };

    const getExistingWallet = () => {
      try {
        const existing = sessionStorage.getItem('buildcoinsWallet');
        return existing ? JSON.parse(existing) : [];
      } catch (error) {
        console.error('Error parsing existing wallet:', error);
        return [];
      }
    };

    // Initialize arrays with existing data
    let allEligibilities = getExistingEligibilities();
    let allCoinLedgers = getExistingCoinLedgers();
    let allWallets = getExistingWallet();

    // Helper function to process coins
    const processCoinsForStorage = (coins) => {
      if (coins <= 0) return 0;
      
      // For very small amounts, round up to 1
      if (coins > 0 && coins < 1) {
        console.log(`Small coin amount ${coins} rounded up to 1`);
        return 1;
      }
      
      // For larger amounts, use normal rounding
      return Math.round(coins);
    };

       // Check each program
       for (const program of rewardPrograms) {
         console.log('\n--- Processing program ---');
         console.log('Program ID:', program._id);
   
         // Accessing reward criteria
         const criteria = program.rewardCriteria.rewardCriteria || [];
         console.log('Extracted criteria:', criteria);
   
         if (!criteria.length) {
           console.log('No criteria found, skipping');
           continue;
         }
   
         // Check if ALL conditions in criteria match
         for (const criterion of criteria) {
           if (!criterion.conditions) continue;
   
           console.log('Checking conditions:', criterion.conditions);
           
           const conditionResults = criterion.conditions.map(condition => {
             const contextValue = getFieldValue(context, condition.field);
             const matches = matchesCondition(contextValue, condition.value, condition.operator);
             
             console.log(`Condition check:`, {
               field: condition.field,
               contextValue: contextValue,
               expectedValue: condition.value,
               operator: condition.operator,
               matches: matches
             });
             
             return matches;
           });
   
           // Evaluate based on the conditional operator
           const allConditionsMatch = criterion.nextOperator === 'AND' 
             ? conditionResults.every(result => result === true) 
             : criterion.nextOperator === 'OR' 
             ? conditionResults.some(result => result === true) 
             : conditionResults.every(result => result === true); // Default to AND if no operator
   
           console.log('All conditions match:', allConditionsMatch);

      // If criteria matches, process reward rules
      if (allConditionsMatch) {
        console.log('Criteria matched! Processing reward rules...');
        
        // Process each reward rule
        for (const rewardRule of program.rewardRules || []) {
          console.log('\nProcessing reward rule:', rewardRule.name);
          
          // Calculate coins based on apply field logic
          const coins = calculateRewardAmount(context, rewardRule);
          console.log('Calculated coins:', coins);

          if (coins > 0) {
            // Get IDs from context
            const consumerId = context.consumerId || context.consumer_id || context.customer_id;
            const partnerId = context.partnerId || context.partner_id;

            console.log('Consumer ID:', consumerId);
            console.log('Partner ID:', partnerId);

            if (consumerId && partnerId) {
              try {
                // Calculate expiry date
                const expiryDate = calculateExpiryDate(program.expiryRules);
                console.log('Calculated expiry date:', expiryDate);

                // Create eligible_at array with generic structure
                const eligibleAt = createEligibleAt(context, partnerId);
                console.log('Eligible at:', eligibleAt);

                // Create redemption caps with generic structure
                const redemptionCaps = createRedemptionCaps(program.redemptionRules, context);
                console.log('Redemption caps:', redemptionCaps);

                // Create expiry array with generic structure
                const expiryArray = createExpiryArray(program.expiryRules, context);
                console.log('Expiry array:', expiryArray);

                // Determine reward application details
                const { immediate, source, destination } = determineRewardApplication(rewardRule);
                console.log('Reward application details:', { immediate, source, destination });

                // Create eligibility with correct field names from schema
                const eligibility = {
                  _id: generateObjectId(),
                  partner_id: partnerId,
                  consumer_id: consumerId,
                  eligible_at: eligibleAt,
                  eligible_buildcoins: processCoinsForStorage(coins),
                  redemption_caps: redemptionCaps,
                  expiry: expiryArray,
                  createdAt: new Date(),
                  created_at: new Date(),
                };

                // FIXED: Add to array instead of overwriting
                allEligibilities.push(eligibility);
                console.log('Eligibility created and added:', eligibility._id);

                // Create coin ledger entry
                const creditTx = {
                  _id: generateObjectId(),
                  consumer_id: context.consumer_id || context.consumerId,
                  partner_id: context.partner_id,
                  build_coins: processCoinsForStorage(coins),
                  transaction_type: 'credit',
                  status: 'approved',
                  reference_id: context.order_id || context.orderId || null,
                  eligibility_id: eligibility._id || null,
                  createdAt: new Date(),
                };

                // FIXED: Add to array instead of overwriting
                allCoinLedgers.push(creditTx);
                console.log('Coin ledger created and added:', creditTx._id);

                // FIXED: Update or create wallet properly
                let existingWallet = allWallets.find(w => w.consumer_id === consumerId);
                
                if (existingWallet) {
                  // Update existing wallet
                  existingWallet.earned_coins += creditTx.build_coins;
                  existingWallet.available_coins = existingWallet.earned_coins - existingWallet.redeemed_coins;
                  existingWallet.locked_coins = Math.max(0, existingWallet.available_coins);
                  existingWallet.transactions.push(creditTx._id);
                  console.log('Updated existing wallet for consumer:', consumerId);
                } else {
                  // Create new wallet
                  const newWallet = {
                    _id: generateObjectId(),
                    consumer_id: consumerId,
                    expired_coins: 0,
                    earned_coins: creditTx.build_coins,
                    redeemed_coins: 0,
                    available_coins: creditTx.build_coins,
                    locked_coins: creditTx.build_coins,
                    transactions: [creditTx._id],
                    createdAt: new Date(),
                  };
                  allWallets.push(newWallet);
                  console.log('Created new wallet for consumer:', consumerId);
                }

                matchedRewards.push({
                  criteria_name: criteria.name,
                  rule_name: rewardRule.name,
                  coins: processCoinsForStorage(coins),
                  coinledger_id: creditTx._id,
                  eligibility_id: eligibility._id,
                  apply_type: rewardRule.reward.apply,
                  expiry_date: expiryDate,
                  immediate: immediate,
                  source: source,
                  destination: destination
                });
              } catch (error) {
                console.error('Error processing reward rule:', error);
                console.error('Error details:', error.message);
              }
            } else {
              console.log('Missing consumer ID or partner ID');
            }
          } else {
            console.log('No coins calculated, skipping');
          }
        }
      } else {
        console.log('Criteria did not match, skipping program');
      }
    }
    }

    // FIXED: Save all accumulated data back to session storage
    sessionStorage.setItem('Eligibility', JSON.stringify(allEligibilities));
    sessionStorage.setItem('coinLedger', JSON.stringify(allCoinLedgers));
    sessionStorage.setItem('buildcoinsWallet', JSON.stringify(allWallets));

    console.log('=== Session Storage Updated ===');
    console.log('Total eligibilities:', allEligibilities.length);
    console.log('Total coin ledgers:', allCoinLedgers.length);
    console.log('Total wallets:', allWallets.length);

    const totalCoins = matchedRewards.reduce((sum, reward) => sum + reward.coins, 0);

    console.log('=== Final Results ===');
    console.log('Matched rewards:', matchedRewards);
    console.log('Total coins:', totalCoins);

    return {
      success: true,
      message: `Processed ${matchedRewards.length} matching rewards`,
      data: {
        rewards: matchedRewards,
        total_coins: totalCoins
      }
    };

  } catch (error) {
    console.error('Error in calculateRewardCoinsBasedOnRules:', error);
    return {
      success: false,
      message: 'Error calculating rewards',
      error: error.message,
      data: { rewards: [], total_coins: 0 }
    };
  }
};




function calculateMaxRedeemableCoins(redemptionCaps, contextParams, availableCoins, orderAmount) {
  console.log('calculateMaxRedeemableCoins called with:', {
    redemptionCaps,
    availableCoins,
    orderAmount
  });

  if (!redemptionCaps || !Array.isArray(redemptionCaps) || redemptionCaps.length === 0) {
    console.log('No redemption caps, returning all available coins:', availableCoins);
    return availableCoins; // No caps, return all available coins
  }

  let maxRedeemable = availableCoins;

  for (const cap of redemptionCaps) {
    console.log('Processing redemption cap:', cap);
    
    // Check if this cap applies to current context
    if (cap.conditions && cap.conditions.length > 0) {
      const conditionsMatch = cap.conditions.every(condition => {
        const contextValue = getFieldValue(contextParams, condition.field);
        const matches = matchesCondition(contextValue, condition.value, condition.operator);
        console.log(`Cap condition check: ${condition.field}=${contextValue} ${condition.operator} ${condition.value} = ${matches}`);
        return matches;
      });
      
      if (!conditionsMatch) {
        console.log('Cap conditions do not match, skipping this cap');
        continue; // This cap doesn't apply
      }
    }

    // Calculate cap based on type
    let capLimit;
    if (cap.redeem.type === 'fixed') {
      capLimit = cap.redeem.value;
      console.log(`Fixed cap: ${capLimit}`);
    } else if (cap.redeem.type === 'percentage') {
      // Determine what the percentage applies to
      if (cap.redeem.apply && cap.redeem.apply.includes('order_amount')) {
        capLimit = Math.floor((orderAmount * cap.redeem.value) / 100);
        console.log(`Percentage of order amount: ${orderAmount} * ${cap.redeem.value}% = ${capLimit}`);
      } else if (cap.redeem.apply && cap.redeem.apply.includes('available_coins')) {
        capLimit = Math.floor((availableCoins * cap.redeem.value) / 100);
        console.log(`Percentage of available coins: ${availableCoins} * ${cap.redeem.value}% = ${capLimit}`);
      } else {
        // Default to percentage of order amount
        capLimit = Math.floor((orderAmount * cap.redeem.value) / 100);
        console.log(`Default percentage of order amount: ${orderAmount} * ${cap.redeem.value}% = ${capLimit}`);
      }
    } else {
      console.log('Unknown cap type, skipping');
      continue; // Unknown type
    }

    // Apply the most restrictive cap (or most generous, depending on business logic)
    // For most restrictive, use Math.min:
    maxRedeemable = Math.min(maxRedeemable, capLimit);
    console.log(`Applied cap limit ${capLimit}, new maxRedeemable: ${maxRedeemable}`);
  }

  const finalResult = Math.max(0, maxRedeemable);
  console.log(`Final max redeemable coins: ${finalResult}`);
  return finalResult;
}



function checkEligibleAt(eligibleAtConditions, contextParams) {
  if (!eligibleAtConditions || !Array.isArray(eligibleAtConditions)) {
    return true; // No conditions means always eligible
  }

  // All conditions must match
  return eligibleAtConditions.every(condition => {
    const contextValue = getFieldValue(contextParams, condition.field);
    const matches = matchesCondition(contextValue, condition.value, condition.operator);
    console.log(`Condition check: field=${condition.field}, contextValue=${contextValue}, expectedValue=${condition.value}, operator=${condition.operator}, matches=${matches}`);
    return matches;
  });
}


function calculateMaxApplicableCoinsFromRedemptionCaps(eligibilities, contextParams, orderAmount) {
  let maxApplicableCoins = 0;
  
  // Collect all applicable redemption caps
  const applicableRedemptionCaps = [];
  
  for (const eligibility of eligibilities) {
    if (!eligibility.redemption_caps || !Array.isArray(eligibility.redemption_caps)) {
      continue;
    }
    
    for (const cap of eligibility.redemption_caps) {
      // Check if this cap applies to current context
      let capApplies = true;
      
      if (cap.conditions && cap.conditions.length > 0) {
        capApplies = cap.conditions.every(condition => {
          const contextValue = getFieldValue(contextParams, condition.field);
          return matchesCondition(contextValue, condition.value, condition.operator);
        });
      }
      
      if (capApplies) {
        applicableRedemptionCaps.push({
          ...cap,
          eligibility_id: eligibility._id,
          eligible_buildcoins: eligibility.eligible_buildcoins
        });
      }
    }
  }
  
  console.log(`Found ${applicableRedemptionCaps.length} applicable redemption caps`);
  
  if (applicableRedemptionCaps.length === 0) {
    // No redemption caps found, use a default (e.g., 3% of order amount)
    maxApplicableCoins = Math.floor(orderAmount * 0.03);
    console.log(`No redemption caps found, using default 3% cap: ${maxApplicableCoins}`);
    return maxApplicableCoins;
  }
  
  // Calculate maximum from all applicable caps
  for (const cap of applicableRedemptionCaps) {
    let capLimit = 0;
    
    if (cap.redeem.type === 'fixed') {
      capLimit = cap.redeem.value;
    } else if (cap.redeem.type === 'percentage') {
      // Determine what the percentage applies to based on apply field
      if (cap.redeem.apply && cap.redeem.apply.includes('order_amount')) {
        capLimit = Math.floor((orderAmount * cap.redeem.value) / 100);
      } else if (cap.redeem.apply && cap.redeem.apply.includes('eligible_coins')) {
        capLimit = Math.floor((cap.eligible_buildcoins * cap.redeem.value) / 100);
      } else {
        // Default to percentage of order amount
        capLimit = Math.floor((orderAmount * cap.redeem.value) / 100);
      }
    }
    
    console.log(`Cap limit calculated: ${capLimit} (type: ${cap.redeem.type}, value: ${cap.redeem.value}, apply: ${cap.redeem.apply})`);
    
    // Take the maximum of all caps (most generous)
    // Or you could take minimum for most restrictive: Math.min(maxApplicableCoins || Infinity, capLimit)
    maxApplicableCoins = Math.max(maxApplicableCoins, capLimit);
  }
  
  console.log(`Final max applicable coins from redemption caps: ${maxApplicableCoins}`);
  return maxApplicableCoins;
}

function checkEligibilityExpiry(eligibility) {
  if (!eligibility.expiry || !Array.isArray(eligibility.expiry)) {
    return true; // No expiry rules means never expires
  }

  const now = new Date();
  
  // Check each expiry condition - if any is still valid, eligibility is not expired
  return eligibility.expiry.some(expiryRule => {
    // Check if conditions match (if any)
    if (expiryRule.conditions && expiryRule.conditions.length > 0) {
      const conditionsMatch = expiryRule.conditions.every(condition => {
        // Basic condition matching - extend this based on your needs
        if (condition.field && condition.operator && condition.value !== undefined) {
          // You can implement specific condition logic here
          return true; // For now, assume conditions match
        }
        return true;
      });
      
      if (!conditionsMatch) return false;
    }

    // Get creation date - try multiple possible field names
    let createdAt;
    if (eligibility.createdAt) {
      createdAt = new Date(eligibility.createdAt);
    } else if (eligibility.created_at) {
      createdAt = new Date(eligibility.created_at);
    } else if (eligibility.createdDate) {
      createdAt = new Date(eligibility.createdDate);
    } else if (eligibility._id && eligibility._id.getTimestamp) {
      // Extract timestamp from MongoDB ObjectId if no explicit creation date
      createdAt = eligibility._id.getTimestamp();
    } else {
      // Fallback to current time if no creation date found
      console.warn('No creation date found for eligibility, using current time as fallback');
      createdAt = new Date();
    }

    // Validate the createdAt date
    if (isNaN(createdAt.getTime())) {
      console.error('Invalid creation date found:', eligibility.createdAt || eligibility.created_at);
      return false; // If we can't determine creation date, consider expired
    }

    // Calculate expiry date based on type and value
    let expiryDate;
    
    switch (expiryRule.type) {
      case 'days':
        expiryDate = new Date(createdAt.getTime() + (expiryRule.value * 24 * 60 * 60 * 1000));
        break;
      case 'months':
        expiryDate = new Date(createdAt);
        expiryDate.setMonth(expiryDate.getMonth() + expiryRule.value);
        break;
      case 'years':
        expiryDate = new Date(createdAt);
        expiryDate.setFullYear(expiryDate.getFullYear() + expiryRule.value);
        break;
      default:
        console.error('Unknown expiry type:', expiryRule.type);
        return false;
    }
    
    const isValid = now <= expiryDate;
    console.log(`Expiry check: created=${createdAt.toISOString()}, expiry=${expiryDate.toISOString()}, now=${now.toISOString()}, valid=${isValid}`);
    return isValid;
  });
}


const findEligibilitiesInSession = (eligibilityIds) => {
  try {
    const eligibilitiesData = sessionStorage.getItem('Eligibility');
    if (!eligibilitiesData) return [];
    
    const eligibilities = JSON.parse(eligibilitiesData);
    const eligibilitiesArray = Array.isArray(eligibilities) ? eligibilities : [eligibilities];
    
    return eligibilitiesArray.filter(eligibility => {
      // Check if _id is in the eligibilityIds array
      const idMatches = eligibilityIds.includes(eligibility._id);
      
      // Check if expiry field exists (not null, not undefined)
      const expiryExists = eligibility.expiry !== undefined && eligibility.expiry !== null;
      
      return idMatches && expiryExists;
    });
    
  } catch (error) {
    console.error('Error finding eligibilities in session:', error);
    return [];
  }
};

const findCoinLedgerInSession = (criteria) => {
  try {
    const coinLedgerData = sessionStorage.getItem('coinLedger');
    if (!coinLedgerData) return [];
    
    let coinLedgers = JSON.parse(coinLedgerData);
    
    // Ensure it's always an array
    if (!Array.isArray(coinLedgers)) {
      coinLedgers = [coinLedgers];
    }
    
    // Handle different parameter types
    if (typeof criteria === 'string') {
      // Single consumer_id parameter
      return coinLedgers.filter(ledger => ledger.consumer_id === criteria);
    }
    
    if (typeof criteria === 'object' && criteria !== null) {
      // Object with multiple criteria
      return coinLedgers.filter(ledger => {
        return Object.keys(criteria).every(key => {
          const criteriaValue = criteria[key];
          const ledgerValue = ledger[key];
          
          // Handle different comparison types
          if (Array.isArray(criteriaValue)) {
            return criteriaValue.includes(ledgerValue);
          }
          
          return ledgerValue === criteriaValue;
        });
      });
    }
    
    // If no criteria provided, return all
    return coinLedgers;
    
  } catch (error) {
    console.error('Error finding coin ledger in session:', error);
    return [];
  }
};


async function getApplicableBuildCoinsFromWallet(query) {
  try {
    const { consumer_id, amount, ...contextParams } = query;

    console.log("Request query:", query);
    
    if (!consumer_id || !amount) {
      return { error: 'consumer_id and amount are required' };
    }

    const orderAmount = parseFloat(amount);

    console.log('Request params:', { consumer_id, amount: orderAmount, contextParams });

    // Get coin ledgers
    const coinledgers = findCoinLedgerInSession({
      consumer_id,
      transaction_type: 'credit',
      status: 'approved',
    });

    console.log(`Found ${coinledgers.length} coin ledgers with all filters`);
    console.log('Filtered ledgers:', coinledgers);

    if (coinledgers.length === 0) {
      return {
        applicable_coins: [],
        total_usable_coins: 0,
        max_applicable_coins: 0,
        message: 'No coin ledgers found'
      };
    }

    // Get all eligibility_ids
    const eligibilityIds = coinledgers
      .map(c => c.eligibility_id)
      .filter(id => id);

    if (eligibilityIds.length === 0) {
      return {
        applicable_coins: [],
        total_usable_coins: 0,
        max_applicable_coins: 0,
        message: 'No eligibilities found'
      };
    }

    console.log(`Found ${eligibilityIds.length} unique eligibility IDs`);

    // Fetch eligibilities
    const eligibilities = findEligibilitiesInSession(eligibilityIds);

    console.log(`Found ${eligibilities.length} active eligibilities`);
    console.log('All eligibilities found (before filtering):', eligibilities);

    // Filter eligibilities based on generic conditions
    const filteredEligibilities = eligibilities.filter(eligibility => {
      // Check if eligibility is still valid (not expired)
      const isNotExpired = checkEligibilityExpiry(eligibility);
      if (!isNotExpired) {
        console.log(`Eligibility ${eligibility._id} is expired`);
        return false;
      }

      // Check eligible_at conditions
      const isEligible = checkEligibleAt(eligibility.eligible_at, contextParams);
      if (!isEligible) {
        console.log(`Eligibility ${eligibility._id} does not match eligible_at conditions`);
        return false;
      }

      console.log(`Eligibility ${eligibility._id} passed all filters`);
      return true;
    });

    console.log(`${filteredEligibilities.length} eligibilities passed filtering`);

    // Calculate maxApplicableCoins using redemption caps from all filtered eligibilities
    const maxApplicableCoins = calculateMaxApplicableCoinsFromRedemptionCaps(
      filteredEligibilities, 
      contextParams, 
      orderAmount
    );

    console.log(`Max applicable coins calculated from redemption caps: ${maxApplicableCoins}`);

    // Match coin ledgers to filtered eligibilities and calculate individual redemption caps
    const applicableLedgers = [];
    
    for (const cl of coinledgers) {
      const matchingEligibility = filteredEligibilities.find(
        fe => fe._id.toString() === cl.eligibility_id?.toString()
      );
      
      if (matchingEligibility) {
        // Calculate maximum redeemable coins based on redemption caps for this specific eligibility
        const maxRedeemableCoins = calculateMaxRedeemableCoins(
          matchingEligibility.redemption_caps, 
          contextParams, 
          cl.build_coins, 
          orderAmount
        );
        
        console.log(`Ledger ${cl._id}: build_coins=${cl.build_coins}, maxRedeemableCoins=${maxRedeemableCoins}`);
        
        if (maxRedeemableCoins > 0) {
          applicableLedgers.push({
            ...cl,
            max_redeemable_coins: maxRedeemableCoins,
            eligibility_details: {
              id: matchingEligibility._id,
              eligible_buildcoins: matchingEligibility.eligible_buildcoins,
              expiry: matchingEligibility.expiry,
              redemption_caps: matchingEligibility.redemption_caps
            }
          });
        }
      }
    }

    console.log(`${applicableLedgers.length} ledgers are applicable`);
    console.log('Applicable ledgers details:', applicableLedgers.map(al => ({
      id: al._id,
      build_coins: al.build_coins,
      max_redeemable_coins: al.max_redeemable_coins
    })));

    // Apply calculated max applicable coins cap properly
    let remainingCapacity = maxApplicableCoins;
    const finalCoinUsage = [];
    let totalUsableCoins = 0;

    // Sort ledgers by creation date (oldest first) or by coins (highest first)
    const sortedLedgers = applicableLedgers.sort((a, b) => {
      return b.build_coins - a.build_coins; // Highest coins first
    });

    console.log('Processing ledgers in order:', sortedLedgers.map(sl => ({
      id: sl._id,
      build_coins: sl.build_coins,
      max_redeemable_coins: sl.max_redeemable_coins
    })));

    for (const cl of sortedLedgers) {
      if (remainingCapacity <= 0) {
        console.log(`No remaining capacity (${remainingCapacity}), stopping`);
        break;
      }
      
      // Use the minimum of available coins, max redeemable, and remaining capacity
      const availableCoins = cl.build_coins;
      const maxRedeemableForThisLedger = cl.max_redeemable_coins;
      const usableCoins = Math.min(availableCoins, maxRedeemableForThisLedger, remainingCapacity);
      
      console.log(`Processing ledger ${cl._id}:`, {
        availableCoins,
        maxRedeemableForThisLedger,
        remainingCapacity,
        usableCoins
      });
      
      if (usableCoins > 0) {
        finalCoinUsage.push({
          ledger_id: cl._id,
          eligibility_id: cl.eligibility_id,
          total_coins: cl.build_coins,
          max_redeemable_coins: cl.max_redeemable_coins,
          usable_coins: usableCoins,
          partner_id: cl.partner_id,
          eligibility_details: cl.eligibility_details,
          created_at: cl.createdAt
        });
        
        remainingCapacity -= usableCoins;
        totalUsableCoins += usableCoins;
        
        console.log(`Added ${usableCoins} coins, remaining capacity: ${remainingCapacity}, total usable: ${totalUsableCoins}`);
      }
    }

    console.log("Final applicable coins:", finalCoinUsage);
    console.log(`Total usable coins: ${totalUsableCoins}`);

    const applicable_coins_response = {
      applicable_coins: finalCoinUsage,
      total_usable_coins: totalUsableCoins,
      max_applicable_coins: maxApplicableCoins,
      remaining_cap: maxApplicableCoins - totalUsableCoins,
      calculation_method: 'redemption_caps',
      summary: {
        total_ledgers_found: coinledgers.length,
        total_eligibilities_found: eligibilities.length,
        filtered_eligibilities: filteredEligibilities.length,
        applicable_ledgers: applicableLedgers.length,
        final_usable_entries: finalCoinUsage.length
      }
    };
    
    return applicable_coins_response;

  } catch (err) {
    console.log("Error in getApplicableBuildCoinsFromWallet:", err);
    console.error('Error fetching applicable build coins:', err);
    return { error: 'Internal Server Error', details: err.message };
  }
}



  // Add this function to clear session data when needed
const clearAllSessionData = () => {
  // Clear all session storage related to the simulator
  sessionStorage.removeItem('buildcoinsWallet');
  sessionStorage.removeItem('coinLedger');
  sessionStorage.removeItem('Eligibility');
  sessionStorage.removeItem('selectedApplicableRule');
  sessionStorage.removeItem('applicableCoinsFormData');
  sessionStorage.removeItem('RewardCoinsFormData');
  sessionStorage.removeItem('ApplicableCoinsFormData');
  console.log('All session data cleared');
};

  const handleClearSession = () => {
    clearAllSessionData();

  // Show confirmation
  alert('Session data cleared successfully!');
  // Optionally refresh the page or reset form data
  // window.location.reload();
  setIsLoading(true);
  setTimeout(() => {
    setIsLoading(false);
  }, 1000);
    setActiveComponent('reward-coins')

};


  const renderComponentTabs = () => (
    <div className="flex border-b bg-gray-50">
      <button
        onClick={() => setActiveComponent('reward-coins')}
        className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors ${
          activeComponent === 'reward-coins'
            ? 'border-blue-500 text-blue-600 bg-white'
            : 'border-transparent text-gray-600 hover:text-gray-800'
        }`}
      >
        <FontAwesomeIcon icon={faCoins} className="mr-2" />
        Reward Coins
      </button>
      <button
        onClick={() => setActiveComponent('applicable-coins')}
        className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors ${
          activeComponent === 'applicable-coins'
            ? 'border-blue-500 text-blue-600 bg-white'
            : 'border-transparent text-gray-600 hover:text-gray-800'
        }`}
      >
        <FontAwesomeIcon icon={faCalculator} className="mr-2" />
        Get Applicable Coins
      </button>
{/*       <button
        onClick={() => setActiveComponent('apply-coins')}
        className={`px-6 py-3 font-medium text-sm border-b-2 transition-colors ${
          activeComponent === 'apply-coins'
            ? 'border-blue-500 text-blue-600 bg-white'
            : 'border-transparent text-gray-600 hover:text-gray-800'
        }`}
      >
        <FontAwesomeIcon icon={faGift} className="mr-2" />
        Apply Coins
      </button> */}
    </div>
  );

  if (isLoading) {
    return (
      <div className="h-full bg-white flex items-center justify-center">
        <div className="text-center">
          <FontAwesomeIcon icon={faSpinner} className="text-4xl text-blue-500 animate-spin mb-4" />
          <p className="text-gray-600">Loading simulator data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen bg-white flex flex-col overflow-hidden">
            <div>new thingg!!!</div>

         {/* Fixed Header */}
<div className="h-16 border-b flex items-center justify-between px-6 bg-white flex-shrink-0">
  {/* Left side - Back button and title */}
  <div className="flex items-center">
    <button
      onClick={handleBackToRules}
      className="mr-4 p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
    >
      <FontAwesomeIcon icon={faArrowLeft} />
    </button>
    <h1 className="text-xl font-semibold text-gray-800">Reward Simulator</h1>
  </div>

  {/* Right side - Clear session button */}
  <button
    onClick={handleClearSession}
    className="flex items-center space-x-2 px-3 py-2 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors border border-red-200 hover:border-red-300"
  >
    <FontAwesomeIcon icon={faTimes} className="text-sm" />
    <span className="text-sm font-medium">Clear Session</span>
  </button>
</div>

      
        {/* Fixed Tabs */}
      <div className="flex-shrink-0">
        {renderComponentTabs()}
      </div>

        {/* Scrollable Content Area */}
      <div className="flex-1 overflow-y-auto">
        <div className="min-h-full">
        {activeComponent === 'reward-coins' && (
          <RewardCoinsComponent
            customers={customers}
            partners={partners}
            categories={categories}
            items={items}
            backendApiUrl={backendApiUrl}
            onCategoryChange={handleCategoryChange}
            calculateRewardCoinsBasedOnRules={calculateRewardCoinsBasedOnRules}
            selectedRuleData={selectedRuleData}
            onPartnerChange={handlePartnerChange}
          />
        )}
        {activeComponent === 'applicable-coins' && (
          <ApplicableCoinsComponent
            customers={customers}
            partners={partners}
            categories={categories}
            items={items}
            backendApiUrl={backendApiUrl}
            setActiveComponent={setActiveComponent}
            onCategoryChange={handleCategoryChange}
            getApplicableBuildCoinsFromWallet={getApplicableBuildCoinsFromWallet}
            selectedRuleData={selectedRuleData}
            onPartnerChange={handlePartnerChange}
          />
        )}
        {activeComponent === 'apply-coins' && (
          <ApplyCoinsComponent
            customers={customers}
            partners={partners}
            categories={categories}
            items={items}
            backendApiUrl={backendApiUrl}
            onCategoryChange={handleCategoryChange}
          />
        )}
        </div>
      </div>
    </div>
  );
};



// Reward Coins Component
const RewardCoinsComponent = ({ customers, partners, categories, items, backendApiUrl,backendApiUrl2,onPartnerChange,onCategoryChange ,calculateRewardCoinsBasedOnRules,selectedRuleData }) => {
  const [formData, setFormData] = useState({
    customerId: DUMMY_CUSTOMER._id,
    partnerIds: [],
    categoryIds: [],
    selectedItems: [],
    totalAmount: 0,
    isEcommerce: "Yes"
  });
  const [response, setResponse] = useState(null);
  const [submitting, setSubmitting] = useState(false);

// Create combined customer list with dummy customer at the top
  const allCustomers = [DUMMY_CUSTOMER, ...customers];

// Session storage key for this component
  const SESSION_KEY = 'RewardCoinsFormData';

  // Helper functions for session storage
  const saveFormDataToSession = (data) => {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
      console.log('Form data saved to session:', data);
    } catch (error) {
      console.error('Error saving form data to session:', error);
    }
  };

  const getFormDataFromSession = () => {
    try {
      const savedData = sessionStorage.getItem(SESSION_KEY);
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        console.log('Form data loaded from session:', parsedData);
        return parsedData;
      }
    } catch (error) {
      console.error('Error loading form data from session:', error);
    }
    return null;
  };

 // NEW: Function to populate form data based on reward criteria
  const populateFormFromRewardCriteria = () => {
    console.log('Populating form data from reward criteria', selectedRuleData);
    if (!selectedRuleData || selectedRuleData.length === 0) {
      console.log('No selectedRuleData available');
      return;
    }

    console.log('Processing selectedRuleData:', selectedRuleData);

    let newFormData = { ...formData };
    let hasChanges = false;

    // Process each rule in selectedRuleData
    selectedRuleData.forEach((rule, ruleIndex) => {
      console.log(`Processing rule ${ruleIndex}:`, rule);

      // Check if rule has rewardCriteria
      if (!rule.rewardCriteria.rewardCriteria || !Array.isArray(rule.rewardCriteria.rewardCriteria)) {
        console.log(`Rule ${ruleIndex} has no rewardCriteria`);
        return;
      }

      // Process each reward criteria
      rule.rewardCriteria.rewardCriteria.forEach((criteria, criteriaIndex) => {
        console.log(`Processing criteria ${criteriaIndex}:`, criteria);

        if (!criteria.conditions || !Array.isArray(criteria.conditions)) {
          console.log(`Criteria ${criteriaIndex} has no conditions`);
          return;
        }

        // Process each condition
        criteria.conditions.forEach((condition, conditionIndex) => {
          console.log(`Processing condition ${conditionIndex}:`, condition);

          const { field, operator, value } = condition;

          switch (field) {
            case 'category':
              const categoryResult = handleCategoryCondition(value, operator, newFormData);
              if (categoryResult.hasChanges) {
                newFormData = categoryResult.formData;
                hasChanges = true;
              }
              break;
            case 'brand':
              const brandResult = handleBrandCondition(value, operator, newFormData);
              if (brandResult.hasChanges) {
                newFormData = brandResult.formData;
                hasChanges = true;
              }
              break;
            case 'is_ecommerce':
              const ecommerceResult = handleEcommerceCondition(value, operator, newFormData);
              if (ecommerceResult.hasChanges) {
                newFormData = ecommerceResult.formData;
                hasChanges = true;
              }
              break;
            default:
              console.log(`Unhandled field: ${field}`);
          }
        });
      });
    });

    if (hasChanges) {
      console.log('Updating form data with changes:', newFormData);
      setFormData(newFormData);
      
      // Trigger category and partner changes to fetch items
      if (newFormData.categoryIds.length > 0) {
        onCategoryChange(newFormData.categoryIds);
      }
      if (newFormData.partnerIds.length > 0) {
        onPartnerChange(newFormData.partnerIds);
      }
    }
  };


 // NEW: Handle category condition - return result instead of directly setting state
  const handleCategoryCondition = (value, operator, currentFormData) => {
    console.log(`Handling category condition: ${value} (${operator})`);
    
    let matchingCategoryIds = [];

    if (operator === '==' || operator === 'in') {
      // Handle both single value and array of values
      const valuesToMatch = Array.isArray(value) ? value : [value];
      
      valuesToMatch.forEach(categoryValue => {
        const matchingCategories = categories.filter(category => {
          const categoryName = category.product_category_name || category.name || '';
          return categoryName.toLowerCase() === categoryValue.toLowerCase();
        });

        matchingCategories.forEach(category => {
          if (!matchingCategoryIds.includes(category._id)) {
            matchingCategoryIds.push(category._id);
          }
        });
      });
    }

    if (matchingCategoryIds.length > 0) {
      console.log('Found matching categories:', matchingCategoryIds);
      const newCategoryIds = [...new Set([...currentFormData.categoryIds, ...matchingCategoryIds])];
      return {
        hasChanges: true,
        formData: {
          ...currentFormData,
          categoryIds: newCategoryIds
        }
      };
    } else {
      console.log(`No categories found matching: ${value}`);
      return { hasChanges: false, formData: currentFormData };
    }
  };


// NEW: Handle brand condition - return result instead of directly setting state
  const handleBrandCondition = (value, operator, currentFormData) => {
    console.log(`Handling brand condition: ${value} (${operator})`);
    
    let matchingPartnerIds = [];

    if (operator === '==' || operator === 'in') {
      // Handle both single value and array of values
      const valuesToMatch = Array.isArray(value) ? value : [value];
      
      valuesToMatch.forEach(brandValue => {
        const matchingPartners = partners.filter(partner => {
          const partnerName = partner.name || partner.brand_name || '';
          return partnerName.toLowerCase() === brandValue.toLowerCase();
        });

        matchingPartners.forEach(partner => {
          if (!matchingPartnerIds.includes(partner._id)) {
            matchingPartnerIds.push(partner._id);
          }
        });
      });
    }

    if (matchingPartnerIds.length > 0) {
      console.log('Found matching partners:', matchingPartnerIds);
      const newPartnerIds = [...new Set([...currentFormData.partnerIds, ...matchingPartnerIds])];
      return {
        hasChanges: true,
        formData: {
          ...currentFormData,
          partnerIds: newPartnerIds
        }
      };
    } else {
      console.log(`No partners found matching: ${value}`);
      return { hasChanges: false, formData: currentFormData };
    }
  };

 // NEW: Handle ecommerce condition - return result instead of directly setting state
  const handleEcommerceCondition = (value, operator, currentFormData) => {
    console.log(`Handling ecommerce condition: ${value} (${operator})`);
    
    if (operator === '==') {
      const ecommerceValue = value === true || value === 'true' || value === 'Yes' ? 'Yes' : 'No';
      return {
        hasChanges: true,
        formData: {
          ...currentFormData,
          isEcommerce: ecommerceValue
        }
      };
    }
    
    return { hasChanges: false, formData: currentFormData };
  };


  // Load saved form data on component mount
  useEffect(() => {
    const savedFormData = getFormDataFromSession();
    if (savedFormData) {
      setFormData(savedFormData);
      // Trigger category change to load items if categories were selected
      if (savedFormData.categoryIds && savedFormData.categoryIds.length > 0) {
        onCategoryChange(savedFormData.categoryIds);
      }
      if (savedFormData.partnerIds && savedFormData.partnerIds.length > 0) {
        onPartnerChange(savedFormData.partnerIds);
      }
    }
  }, []);

  // NEW: Effect to populate form when selectedRuleData changes and dependencies are ready
  useEffect(() => {
    if (selectedRuleData && selectedRuleData.length > 0 && categories.length > 0 && partners.length > 0) {
      console.log('selectedRuleData changed, populating form');
      // Add a small delay to ensure all data is loaded
      setTimeout(() => {
        populateFormFromRewardCriteria();
      }, 100);
    }
  }, [selectedRuleData, categories, partners]);

  // Save form data whenever it changes (debounced to avoid excessive saves)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      saveFormDataToSession(formData);
    }, 500); // 500ms debounce

    return () => clearTimeout(timeoutId);
  }, [formData]);

  // Handle category selection change
  const handleCategorySelection = (selectedIds) => {
    setFormData(prev => ({ ...prev, categoryIds: selectedIds }));
    onCategoryChange(selectedIds); // This will trigger items fetch
  };

  const handlePartnerSelection = (selectedIds) => {
    setFormData(prev => ({ ...prev, partnerIds: selectedIds }));
    onPartnerChange(selectedIds); // Trigger logic in parent to fetch data based on partner IDs
  };


  const handleSubmit = async () => {

     // Get selected partner names
    const selectedPartnerNames = formData.partnerIds.map(partnerId => {
      const partner = partners.find(p => p._id === partnerId);
      return partner ? partner.name : '';
    }).filter(name => name !== '');

    // Get selected category names
    const selectedCategoryNames = formData.categoryIds.map(categoryId => {
      const category = categories.find(c => c._id === categoryId);
      return category ? category.product_category_name : '';
    }).filter(name => name !== '');

    // Get partner buildcoins_partner_id (using first selected partner)
    const selectedPartnerId = formData.partnerIds.length > 0 ? 
      partners.find(p => p._id === formData.partnerIds[0])?._id/* buildcoins_partner_id */ || '' : '';

    // Process selected items with brand matching
    const processedItems = formData.selectedItems.map(item => {
      // Find the partner/vendor that matches this item's vendor_id
      const matchingPartner = partners.find(partner => partner._id === item.vendor_id);
      
      return {
        name: item.product_name || item.name,
        price: item.price,
        quantity: item.quantity,
        brand: matchingPartner ? matchingPartner.name : '', // Brand name from matching partner
        _id: item._id
      };
    });

    let selectedCustomer = null;

    if (formData.customerId) {
      selectedCustomer = customers.find(customer => customer._id === formData.customerId);
    }else {
      selectedCustomer = DUMMY_CUSTOMER;
    }

    console.log(selectedCustomer)

    const requestData = {
      consumer_id: formData.customerId,
      customer_type:selectedCustomer?.customer_type || DUMMY_CUSTOMER.customer_type,
      brand: selectedPartnerNames, // Array of selected partner names
      category: selectedCategoryNames, // Array of selected category names
      items: processedItems, // Processed items with brand matching
      totalAmount: formData.totalAmount,
      is_ecommerce: formData.isEcommerce,
      partner_id: selectedPartnerId, // buildcoins_partner_id of selected partner
      order_id: generateObjectId()
    };

    console.log('Request Data:', requestData); // For debugging

    setSubmitting(true);

     // Save form data to session when submitting
    saveFormDataToSession(formData);

    const data = await calculateRewardCoinsBasedOnRules(requestData);
    console.log('Response Data For debuggig rewards:', data); // For debugging
      setResponse(data); 
      setSubmitting(false);
    /* try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/calculate-reward-coins`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(requestData)
      });
      const data = await response.json();
      setResponse(data);
    } catch (error) {
      console.error('Error submitting reward coins:', error);
      setResponse({ error: 'Failed to process request' });
    } finally {
      setSubmitting(false);
    } */
  };

  const calculateTotal = () => {
    const total = formData.selectedItems.reduce((sum, item) => {
      return sum + (item.price * item.quantity);
    }, 0);
    setFormData(prev => ({ ...prev, totalAmount: total }));
  };

  useEffect(() => {
    calculateTotal();
  }, [formData.selectedItems]);

   // NEW: Add a button to manually populate from criteria
  const handlePopulateFromCriteria = () => {
    populateFormFromRewardCriteria();
  };

  // NEW: Add a button to clear form
  const handleClearForm = () => {
    setFormData({
      customerId: DUMMY_CUSTOMER._id,
      partnerIds: [],
      categoryIds: [],
      selectedItems: [],
      totalAmount: 0,
      isEcommerce: "Yes"
    });
    setResponse(null);
  };

  return (
    <div className="p-6 mb-20 min-h-full">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg border border-gray-200">
          <div className="p-6 border-b border-gray-200">
            <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              <FontAwesomeIcon icon={faCoins} className="mr-2 text-yellow-500" />
              Calculate Reward Coins
            </h2>

              {/* NEW: Action buttons */}
{/*               <div className="flex space-x-2">
                <button
                  onClick={handlePopulateFromCriteria}
                  className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors"
                  title="Populate form from selected rule criteria"
                >
                  <FontAwesomeIcon icon={faPlay} className="mr-1" />
                  Auto-Fill
                </button>
                <button
                  onClick={handleClearForm}
                  className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200 transition-colors"
                  title="Clear form"
                >
                  <FontAwesomeIcon icon={faRemove} className="mr-1" />
                  Clear
                </button>
              </div> */}
            </div>

            {/* NEW: Show selected rule info */}
{/*             {selectedRuleData && selectedRuleData.length > 0 && (
              <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <h3 className="text-sm font-medium text-blue-800 mb-2">
                  <FontAwesomeIcon icon={faGift} className="mr-2" />
                  Selected Rule Criteria ({selectedRuleData.length} rule{selectedRuleData.length !== 1 ? 's' : ''})
                </h3>
                <div className="space-y-2">
                  {selectedRuleData.map((rule, index) => (
                    <div key={index} className="text-xs text-blue-700">
                      {rule.rewardCriteria && rule.rewardCriteria.length > 0 && (
                        <div>
                          <strong>Rule {index + 1}:</strong> {rule.rewardCriteria[0].name || 'Unnamed criteria'}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )} */}
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Customer Selection */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faUser} className="mr-2" />
                  Select Customer
                </label>
                <select
                  value={formData.customerId}
                  onChange={(e) => setFormData(prev => ({ ...prev, customerId: e.target.value }))}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Choose a customer...</option>
                  {allCustomers.map(customer => (
                    <option key={customer._id} value={customer._id}>
                      {customer.customer_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Is Ecommerce Toggle */}
             <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faShoppingCart} className="mr-2" />
                  Is Ecommerce
                </label>
                <div className="flex items-center space-x-3">
                  <button
                    type="button"
                    onClick={() => setFormData(prev => ({ 
                      ...prev, 
                      isEcommerce: prev.isEcommerce === "Yes" ? "No" : "Yes" // Toggle between "Yes" and "No"
                    }))}
                    className={`flex items-center space-x-2 px-4 py-3 rounded-lg border transition-colors ${
                      formData.isEcommerce === "Yes"
                        ? 'bg-green-50 border-green-300 text-green-700' 
                        : 'bg-red-50 border-red-300 text-red-700'
                    }`}
                  >
                    <FontAwesomeIcon 
                      icon={formData.isEcommerce === "Yes" ? faToggleOn : faToggleOff} 
                      className={`text-xl ${formData.isEcommerce === "Yes" ? 'text-green-600' : 'text-red-600'}`}
                    />
                    <span className="font-medium">
                      {formData.isEcommerce} {/* This will display "Yes" or "No" */}
                    </span>
                  </button>
                </div>
              </div>

              {/* Partners Multi-select */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faStore} className="mr-2" />
                  Select Partners
                </label>
                <MultiSelectDropdown
                  options={partners}
                  selectedValues={formData.partnerIds}
                  onChange={handlePartnerSelection}
                  placeholder="Choose partners..."
                  displayKey="name"
                  valueKey="_id"
                />
              </div>

              {/* Categories Multi-select */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faTag} className="mr-2" />
                  Select Categories
                </label>
                <MultiSelectDropdown
                  options={categories}
                  selectedValues={formData.categoryIds}
                  onChange={handleCategorySelection}
                  placeholder="Choose categories..."
                  displayKey="product_category_name"
                  valueKey="_id"
                />
              </div>

              {/* Items and Quantities */}
              <div className="md:col-span-2" >
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faBox} className="mr-2" />
                  Select Items
                </label>
                <ItemSelector
                  items={items}
                  selectedItems={formData.selectedItems}
                  onChange={(selected) => setFormData(prev => ({ ...prev, selectedItems: selected }))}
                />
              </div>
            </div>

            {/* NEW: Show matching criteria summary */}
{/*             {selectedRuleData && selectedRuleData.length > 0 && (
              <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                <h4 className="text-sm font-medium text-green-800 mb-2">
                  <FontAwesomeIcon icon={faCheck} className="mr-2" />
                  Auto-populated Fields Summary
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs">
                  <div>
                    <span className="text-green-600 font-medium">Categories:</span>
                    <div className="text-green-700">
                      {formData.categoryIds.length > 0 ? (
                        formData.categoryIds.map(catId => {
                          const category = categories.find(c => c._id === catId);
                          return category ? category.product_category_name : catId;
                        }).join(', ')
                      ) : 'None selected'}
                    </div>
                  </div>
                  <div>
                    <span className="text-green-600 font-medium">Partners:</span>
                    <div className="text-green-700">
                      {formData.partnerIds.length > 0 ? (
                        formData.partnerIds.map(partnerId => {
                          const partner = partners.find(p => p._id === partnerId);
                          return partner ? partner.name : partnerId;
                        }).join(', ')
                      ) : 'None selected'}
                    </div>
                  </div>
                  <div>
                    <span className="text-green-600 font-medium">E-commerce:</span>
                    <div className="text-green-700">{formData.isEcommerce}</div>
                  </div>
                </div>
              </div>
            )} */}


            {/* Total Amount Display */}
            <div className="mt-6 p-4 bg-gray-50 rounded-lg">
              <div className="flex justify-between items-center">
                <span className="text-lg font-medium text-gray-700">
                  <FontAwesomeIcon icon={faRupeeSign} className="mr-2" />
                  Total Order Amount:
                </span>
                <span className="text-2xl font-bold text-green-600">
                  ₹{formData.totalAmount.toLocaleString()}
                </span>
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-6">
              <button
                onClick={handleSubmit}
                disabled={submitting || !formData.customerId}
                className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {submitting ? (
                  <>
                    <FontAwesomeIcon icon={faSpinner} className="mr-2 animate-spin" />
                    Processing...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faPlay} className="mr-2" />
                    Calculate Reward Coins
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Response Section */}
{response && (
  <div className="p-6">
    <div className="flex items-center mb-4">
      <FontAwesomeIcon icon={faCoins} className="mr-2 text-yellow-500 text-xl" />
      <h3 className="text-lg font-semibold text-gray-800">Reward Calculation Result</h3>
    </div>
    
    {response.error ? (
      <div className="bg-gradient-to-r from-red-50 to-red-100 border-l-4 border-red-500 rounded-lg p-6 shadow-md">
        <div className="flex items-center">
          <FontAwesomeIcon icon={faTimes} className="text-red-500 text-xl mr-3" />
          <div>
            <h4 className="text-red-800 font-semibold text-lg">Error Occurred</h4>
            <p className="text-red-700 mt-1">{response.error}</p>
          </div>
        </div>
      </div>
    ) : (
      <div className="space-y-6">
        {/* Success Header */}
        <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-500 rounded-lg p-4 shadow-md">
          <div className="flex items-center">
            <FontAwesomeIcon icon={faCheck} className="text-green-500 text-2xl mr-3" />
            <div>
              <h4 className="text-green-800 font-bold text-lg">Reward Coins Calculated Successfully!</h4>
              <p className="text-green-700 text-sm mt-1">Your reward calculation has been processed</p>
            </div>
          </div>
        </div>

        {/* Main Results Card */}
        {response.coins_awarded !== undefined && (
          <div className="bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 border border-blue-200 rounded-xl p-6 shadow-lg">
            <div className="text-center">
              <FontAwesomeIcon icon={faCoins} className="text-yellow-500 text-4xl mb-3" />
              <h4 className="text-2xl font-bold text-gray-800 mb-2">Coins Awarded</h4>
              <div className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500 mb-4">
                {response.coins_awarded || 0}
              </div>
              <p className="text-gray-600">BuildCoins have been added to your account</p>
            </div>
          </div>
        )}

        {/* Order Details */}
        {response.order_id && (
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-200 rounded-lg p-4 shadow-md">
            <h4 className="font-semibold text-purple-800 mb-3 flex items-center">
              <FontAwesomeIcon icon={faHashtag} className="mr-2" />
              Order Information
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div className="bg-white bg-opacity-50 rounded-lg p-3">
                <span className="text-purple-600 font-medium">Order ID:</span>
                <div className="font-mono text-purple-800 break-all">{response.order_id}</div>
              </div>
              {response.total_amount && (
                <div className="bg-white bg-opacity-50 rounded-lg p-3">
                  <span className="text-purple-600 font-medium">Order Amount:</span>
                  <div className="font-bold text-purple-800">₹{response.total_amount.toLocaleString()}</div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Applied Rules */}
        {response.applied_rules && response.applied_rules.length > 0 && (
          <div className="bg-gradient-to-r from-teal-50 to-cyan-50 border border-teal-200 rounded-lg p-4 shadow-md">
            <h4 className="font-semibold text-teal-800 mb-3 flex items-center">
              <FontAwesomeIcon icon={faGift} className="mr-2" />
              Applied Rules ({response.applied_rules.length})
            </h4>
            <div className="space-y-3">
              {response.applied_rules.map((rule, index) => (
                <div key={index} className="bg-white bg-opacity-60 rounded-lg p-3 border-l-4 border-teal-400">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <h5 className="font-medium text-teal-800">{rule.rule_name || `Rule ${index + 1}`}</h5>
                      {rule.description && (
                        <p className="text-teal-600 text-sm mt-1">{rule.description}</p>
                      )}
                    </div>
                    <span className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-medium">
                      +{rule.coins_awarded || 0} coins
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Transaction Details */}
        {response.transaction_id && (
          <div className="bg-gradient-to-r from-orange-50 to-yellow-50 border border-orange-200 rounded-lg p-4 shadow-md">
            <h4 className="font-semibold text-orange-800 mb-3 flex items-center">
              <FontAwesomeIcon icon={faDollarSign} className="mr-2" />
              Transaction Details
            </h4>
            <div className="bg-white bg-opacity-50 rounded-lg p-3">
              <span className="text-orange-600 font-medium">Transaction ID:</span>
              <div className="font-mono text-orange-800 break-all">{response.transaction_id}</div>
            </div>
          </div>
        )}

        {/* Customer Information */}
        {response.consumer_id && (
          <div className="bg-gradient-to-r from-rose-50 to-pink-50 border border-rose-200 rounded-lg p-4 shadow-md">
            <h4 className="font-semibold text-rose-800 mb-3 flex items-center">
              <FontAwesomeIcon icon={faUser} className="mr-2" />
              Customer Information
            </h4>
            <div className="bg-white bg-opacity-50 rounded-lg p-3">
              <span className="text-rose-600 font-medium">Consumer ID:</span>
              <div className="font-mono text-rose-800">{response.consumer_id}</div>
            </div>
          </div>
        )}

        {/* Success Actions */}
{/*         <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4 shadow-md">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
            <div className="flex items-center text-green-700">
              <FontAwesomeIcon icon={faCheck} className="mr-2 text-green-500" />
              <span className="font-medium">Transaction completed successfully!</span>
            </div>
            <div className="flex space-x-3">
              <button
                onClick={() => setResponse(null)}
                className="bg-white text-green-700 border border-green-300 px-4 py-2 rounded-lg hover:bg-green-50 transition-colors flex items-center"
              >
                <FontAwesomeIcon icon={faTimes} className="mr-2" />
                Clear Result
              </button>
              <button
                onClick={() => window.print()}
                className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center"
              >
                <FontAwesomeIcon icon={faPlay} className="mr-2" />
                Print Receipt
              </button>
            </div>
          </div>
        </div> */}

        {/* Raw Response (for debugging) */}
          <div className="bg-gradient-to-r from-gray-50 to-slate-50 border border-gray-200 rounded-lg p-4 shadow-md">
            <div className="flex items-center justify-between mb-3">
              <h4 className="font-semibold text-gray-800 flex items-center">
                <FontAwesomeIcon icon={faCalculator} className="mr-2" />
                Raw Response (Debug)
              </h4>
              <button
                onClick={() => {
                  const jsonString = JSON.stringify(response, null, 2);
                  navigator.clipboard.writeText(jsonString);
                  alert('Response copied to clipboard!');
                }}
                className="text-xs bg-gray-200 text-gray-700 px-2 py-1 rounded hover:bg-gray-300 transition-colors"
              >
                Copy JSON
              </button>
            </div>
            <div className="bg-gray-800 rounded-lg p-4 overflow-auto max-h-64">
              <pre className="text-green-400 text-xs font-mono whitespace-pre-wrap">
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>
          </div>
      </div>
    )}
  </div>
)}

        </div>
      </div>
    </div>
  );
};

// Applicable Coins Component
const ApplicableCoinsComponent = ({ customers, partners, categories, items, backendApiUrl, backendApiUrl2, setActiveComponent,onPartnerChange,onCategoryChange,getApplicableBuildCoinsFromWallet,selectedRuleData  }) => {
  const [formData, setFormData] = useState({
    customerId: DUMMY_CUSTOMER._id,
    partnerIds: [],
    categoryIds: [],
    selectedItems: [],
    totalAmount: 0,
    isEcommerce: "Yes"
  });
  const [response, setResponse] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // Create combined customer list with dummy customer at the top
  const allCustomers = [DUMMY_CUSTOMER, ...customers];

// Session storage key for this component
  const SESSION_KEY = 'ApplicableCoinsFormData';

// NEW: Function to populate form data based on reward criteria
  const populateFormFromRewardCriteria = () => {
    console.log('Populating form data from reward criteria', selectedRuleData);
    if (!selectedRuleData || selectedRuleData.length === 0) {
      console.log('No selectedRuleData available');
      return;
    }

    console.log('Processing selectedRuleData:', selectedRuleData);

    let newFormData = { ...formData };
    let hasChanges = false;

    // Process each rule in selectedRuleData
    selectedRuleData.forEach((rule, ruleIndex) => {
      console.log(`Processing rule ${ruleIndex}:`, rule);

      // Check if rule has rewardCriteria
      if (!rule.rewardCriteria.rewardCriteria || !Array.isArray(rule.rewardCriteria.rewardCriteria)) {
        console.log(`Rule ${ruleIndex} has no rewardCriteria`);
        return;
      }

      // Process each reward criteria
      rule.rewardCriteria.rewardCriteria.forEach((criteria, criteriaIndex) => {
        console.log(`Processing criteria ${criteriaIndex}:`, criteria);

        if (!criteria.conditions || !Array.isArray(criteria.conditions)) {
          console.log(`Criteria ${criteriaIndex} has no conditions`);
          return;
        }

        // Process each condition
        criteria.conditions.forEach((condition, conditionIndex) => {
          console.log(`Processing condition ${conditionIndex}:`, condition);

          const { field, operator, value } = condition;

          switch (field) {
            case 'category':
              const categoryResult = handleCategoryCondition(value, operator, newFormData);
              if (categoryResult.hasChanges) {
                newFormData = categoryResult.formData;
                hasChanges = true;
              }
              break;
            case 'brand':
              const brandResult = handleBrandCondition(value, operator, newFormData);
              if (brandResult.hasChanges) {
                newFormData = brandResult.formData;
                hasChanges = true;
              }
              break;
            case 'is_ecommerce':
              const ecommerceResult = handleEcommerceCondition(value, operator, newFormData);
              if (ecommerceResult.hasChanges) {
                newFormData = ecommerceResult.formData;
                hasChanges = true;
              }
              break;
            default:
              console.log(`Unhandled field: ${field}`);
          }
        });
      });
    });

    if (hasChanges) {
      console.log('Updating form data with changes:', newFormData);
      setFormData(newFormData);
      
      // Trigger category and partner changes to fetch items
      if (newFormData.categoryIds.length > 0) {
        onCategoryChange(newFormData.categoryIds);
      }
      if (newFormData.partnerIds.length > 0) {
        onPartnerChange(newFormData.partnerIds);
      }
    }
  };

  // NEW: Handle category condition - return result instead of directly setting state
  const handleCategoryCondition = (value, operator, currentFormData) => {
    console.log(`Handling category condition: ${value} (${operator})`);
    
    let matchingCategoryIds = [];

    if (operator === '==' || operator === 'in') {
      // Handle both single value and array of values
      const valuesToMatch = Array.isArray(value) ? value : [value];
      
      valuesToMatch.forEach(categoryValue => {
        const matchingCategories = categories.filter(category => {
          const categoryName = category.product_category_name || category.name || '';
          return categoryName.toLowerCase() === categoryValue.toLowerCase();
        });

        matchingCategories.forEach(category => {
          if (!matchingCategoryIds.includes(category._id)) {
            matchingCategoryIds.push(category._id);
          }
        });
      });
    }

    if (matchingCategoryIds.length > 0) {
      console.log('Found matching categories:', matchingCategoryIds);
      const newCategoryIds = [...new Set([...currentFormData.categoryIds, ...matchingCategoryIds])];
      return {
        hasChanges: true,
        formData: {
          ...currentFormData,
          categoryIds: newCategoryIds
        }
      };
    } else {
      console.log(`No categories found matching: ${value}`);
      return { hasChanges: false, formData: currentFormData };
    }
  };

  // NEW: Handle brand condition - return result instead of directly setting state
  const handleBrandCondition = (value, operator, currentFormData) => {
    console.log(`Handling brand condition: ${value} (${operator})`);
    
    let matchingPartnerIds = [];

    if (operator === '==' || operator === 'in') {
      // Handle both single value and array of values
      const valuesToMatch = Array.isArray(value) ? value : [value];
      
      valuesToMatch.forEach(brandValue => {
        const matchingPartners = partners.filter(partner => {
          const partnerName = partner.name || partner.brand_name || '';
          return partnerName.toLowerCase() === brandValue.toLowerCase();
        });

        matchingPartners.forEach(partner => {
          if (!matchingPartnerIds.includes(partner._id)) {
            matchingPartnerIds.push(partner._id);
          }
        });
      });
    }

    if (matchingPartnerIds.length > 0) {
      console.log('Found matching partners:', matchingPartnerIds);
      const newPartnerIds = [...new Set([...currentFormData.partnerIds, ...matchingPartnerIds])];
      return {
        hasChanges: true,
        formData: {
          ...currentFormData,
          partnerIds: newPartnerIds
        }
      };
    } else {
      console.log(`No partners found matching: ${value}`);
      return { hasChanges: false, formData: currentFormData };
    }
  };

  // NEW: Handle ecommerce condition - return result instead of directly setting state
  const handleEcommerceCondition = (value, operator, currentFormData) => {
    console.log(`Handling ecommerce condition: ${value} (${operator})`);
    
    if (operator === '==') {
      const ecommerceValue = value === true || value === 'true' || value === 'Yes' ? 'Yes' : 'No';
      return {
        hasChanges: true,
        formData: {
          ...currentFormData,
          isEcommerce: ecommerceValue
        }
      };
    }
    
    return { hasChanges: false, formData: currentFormData };
  };


  // Helper functions for session storage
  const saveFormDataToSession = (data) => {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
      console.log('Applicable Coins form data saved to session:', data);
    } catch (error) {
      console.error('Error saving applicable coins form data to session:', error);
    }
  };

  const getFormDataFromSession = () => {
    try {
      const savedData = sessionStorage.getItem(SESSION_KEY);
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        console.log('Applicable Coins form data loaded from session:', parsedData);
        return parsedData;
      }
    } catch (error) {
      console.error('Error loading applicable coins form data from session:', error);
    }
    return null;
  };


   // Load saved form data on component mount
  useEffect(() => {
    const savedFormData = getFormDataFromSession();
    if (savedFormData) {
      setFormData(savedFormData);
      // Trigger category change to load items if categories were selected
      if (savedFormData.categoryIds && savedFormData.categoryIds.length > 0) {
        onCategoryChange(savedFormData.categoryIds);
      }
      if (savedFormData.partnerIds && savedFormData.partnerIds.length > 0) {
        onPartnerChange(savedFormData.partnerIds);
      }
    }
  }, []);

  // NEW: Effect to populate form when selectedRuleData changes and dependencies are ready
  useEffect(() => {
    if (selectedRuleData && selectedRuleData.length > 0 && categories.length > 0 && partners.length > 0) {
      console.log('selectedRuleData changed in ApplicableCoins, populating form');
      // Add a small delay to ensure all data is loaded
      setTimeout(() => {
        populateFormFromRewardCriteria();
      }, 100);
    }
  }, [selectedRuleData, categories, partners]);

  // Save form data whenever it changes (debounced to avoid excessive saves)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      saveFormDataToSession(formData);
    }, 500); // 500ms debounce

    return () => clearTimeout(timeoutId);
  }, [formData]);

  // Add this function to handle category selection change
  const handleCategorySelection = (selectedIds) => {
    setFormData(prev => ({ ...prev, categoryIds: selectedIds }));
    onCategoryChange(selectedIds); // This will trigger items fetch
  };

   const handlePartnerSelection = (selectedIds) => {
    setFormData(prev => ({ ...prev, partnerIds: selectedIds }));
    onPartnerChange(selectedIds); // Trigger logic in parent to fetch data based on partner IDs
  };

  const handleSubmit = async () => {
      // Get selected partner names
    const selectedPartnerNames = formData.partnerIds.map(partnerId => {
      const partner = partners.find(p => p._id === partnerId);
      return partner ? partner.name : '';
    }).filter(name => name !== '');

    // Get selected category names
    const selectedCategoryNames = formData.categoryIds.map(categoryId => {
      const category = categories.find(c => c._id === categoryId);
      return category ? category.product_category_name : '';
    }).filter(name => name !== '');

    // Get partner buildcoins_partner_id (using first selected partner)
    const selectedPartnerId = formData.partnerIds.length > 0 ? 
      partners.find(p => p._id === formData.partnerIds[0])?._id/* buildcoins_partner_id */ || '' : '';

    // Process selected items with brand matching
    const processedItems = formData.selectedItems.map(item => {
      // Find the partner/vendor that matches this item's vendor_id
      const matchingPartner = partners.find(partner => partner._id === item.vendor_id);
      
      return {
        name: item.product_name || item.name,
        price: item.price,
        quantity: item.quantity,
        brand: matchingPartner ? matchingPartner.name : '', // Brand name from matching partner
        _id: item._id
      };
    });

    let selectedCustomer = null;

    if (formData.customerId) {
      selectedCustomer = customers.find(customer => customer._id === formData.customerId);
    }else {
      selectedCustomer = DUMMY_CUSTOMER;
    }

    console.log(selectedCustomer)

/*     const requestData = {
      consumer_id: formData.customerId,
      customer_type:selectedCustomer?.customer_type || DUMMY_CUSTOMER.customer_type,
      brand: selectedPartnerNames, // Array of selected partner names
      category: selectedCategoryNames, // Array of selected category names
      items: processedItems, // Processed items with brand matching
      totalAmount: formData.totalAmount,
      is_ecommerce: formData.isEcommerce,
      partner_id: selectedPartnerId, // buildcoins_partner_id of selected partner
      order_id: generateObjectId()
    }; */

    const rq = {
      consumer_id: formData.customerId,
      customer_type:selectedCustomer?.customer_type || DUMMY_CUSTOMER.customer_type,
      amount: formData.totalAmount,
      brand: selectedPartnerNames,
      category: selectedCategoryNames,
      items: processedItems,
      totalAmount: formData.totalAmount,
      is_ecommerce: formData.isEcommerce,
      partner_id: selectedPartnerId,
      order_id: generateObjectId()
    }

    setSubmitting(true);

    // Save form data to session when submitting
    saveFormDataToSession(formData);

    const data = await getApplicableBuildCoinsFromWallet(rq)
     console.log('Response Data For APPLICABLE COINS debuggig:', data); // For debugging
    setResponse(data);
    setSubmitting(false);
    /* try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/get-applicable-buildcoins-from-wallet?consumer_id=${requestData.consumer_id}&partner_id=${requestData.partner_id}&brand=${requestData.brand}&category=${requestData.category}&items=${requestData.items}&amount=${requestData.totalAmount}&is_ecommerce=${requestData.is_ecommerce}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        //body: JSON.stringify(formData)
      });
      const data = await response.json();
      console.log('Applicable Coins Response:', data);
      setResponse(data);
    } catch (error) {
      console.error('Error getting applicable coins:', error);
      setResponse({ error: 'Failed to process request' });
    } finally {
      setSubmitting(false);
    } */
  };

    const handleApplyRule = (rule) => {
    // Store the selected rule data and switch to apply coins component
    sessionStorage.setItem('selectedApplicableRule', JSON.stringify(rule));
    sessionStorage.setItem('applicableCoinsFormData', JSON.stringify(formData));
    setActiveComponent('apply-coins');
  };

  const calculateTotal = () => {
    const total = formData.selectedItems.reduce((sum, item) => {
      return sum + (item.selling_price * item.quantity);
    }, 0);
    setFormData(prev => ({ ...prev, totalAmount: total }));
  };

  useEffect(() => {
    calculateTotal();
  }, [formData.selectedItems]);

  return (
    <div className="p-6 mb-20 min-h-full">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg border border-gray-200">
          <div className="p-6 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              <FontAwesomeIcon icon={faCalculator} className="mr-2 text-blue-500" />
              Get Applicable Coins
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Customer Selection */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faUser} className="mr-2" />
                  Select Customer
                </label>
                <select
                  value={formData.customerId}
                  onChange={(e) => setFormData(prev => ({ ...prev, customerId: e.target.value }))}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Choose a customer...</option>
                  {allCustomers.map(customer => (
                    <option key={customer._id} value={customer._id}>
                      {customer.customer_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Is Ecommerce Toggle */}
<div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faShoppingCart} className="mr-2" />
                  Is Ecommerce
                </label>
                <div className="flex items-center space-x-3">
                  <button
                    type="button"
                    onClick={() => setFormData(prev => ({ 
                      ...prev, 
                      isEcommerce: prev.isEcommerce === "Yes" ? "No" : "Yes" // Toggle between "Yes" and "No"
                    }))}
                    className={`flex items-center space-x-2 px-4 py-3 rounded-lg border transition-colors ${
                      formData.isEcommerce === "Yes"
                        ? 'bg-green-50 border-green-300 text-green-700' 
                        : 'bg-red-50 border-red-300 text-red-700'
                    }`}
                  >
                    <FontAwesomeIcon 
                      icon={formData.isEcommerce === "Yes" ? faToggleOn : faToggleOff} 
                      className={`text-xl ${formData.isEcommerce === "Yes" ? 'text-green-600' : 'text-red-600'}`}
                    />
                    <span className="font-medium">
                      {formData.isEcommerce} {/* This will display "Yes" or "No" */}
                    </span>
                  </button>
                </div>
              </div>

              {/* Partners Multi-select */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faStore} className="mr-2" />
                  Select Partners
                </label>
                <MultiSelectDropdown
                  options={partners}
                  selectedValues={formData.partnerIds}
                  onChange={handlePartnerSelection}
                  placeholder="Choose partners..."
                  displayKey="name"
                  valueKey="_id"
                />
              </div>

              {/* Categories Multi-select */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faTag} className="mr-2" />
                  Select Categories
                </label>
                <MultiSelectDropdown
                  options={categories}
                  selectedValues={formData.categoryIds}
                  onChange={handleCategorySelection}
                  placeholder="Choose categories..."
                  displayKey="product_category_name"
                  valueKey="_id"
                />
              </div>

              {/* Items and Quantities */}
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faBox} className="mr-2" />
                  Select Items
                </label>
                <ItemSelector
                  items={items}
                  selectedItems={formData.selectedItems}
                  onChange={(selected) => setFormData(prev => ({ ...prev, selectedItems: selected }))}
                />
              </div>
            </div>

            {/* Total Amount Display */}
            <div className="mt-6 p-4 bg-gray-50 rounded-lg">
              <div className="flex justify-between items-center">
                <span className="text-lg font-medium text-gray-700">
                  <FontAwesomeIcon icon={faRupeeSign} className="mr-2" />
                  Total Order Amount:
                </span>
                <span className="text-2xl font-bold text-green-600">
                  ₹{formData.totalAmount.toLocaleString()}
                </span>
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-6">
              <button
                onClick={handleSubmit}
                disabled={submitting || !formData.customerId}
                className="w-full bg-green-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {submitting ? (
                  <>
                    <FontAwesomeIcon icon={faSpinner} className="mr-2 animate-spin" />
                    Processing...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCalculator} className="mr-2" />
                    Get Applicable Coins
                  </>
                )}
              </button>
            </div>
          </div>

{/* Response Section with Apply Buttons */}
{response && (
  <div className="p-6">
    <h3 className="text-lg font-semibold text-gray-800 mb-4">Applicable Coins</h3>
    {response.error ? (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-700">{response.error}</p>
      </div>
    ) : (
      <div className="space-y-4">
        {/* Summary Information */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h4 className="font-semibold text-blue-800 mb-3">Summary</h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
            <div className="text-center">
              <span className="block text-blue-600 text-xs">Total Usable Coins</span>
              <div className="font-bold text-blue-800 text-lg">{response.total_usable_coins || 0}</div>
            </div>
            <div className="text-center">
              <span className="block text-blue-600 text-xs">Max Applicable</span>
              <div className="font-bold text-blue-800 text-lg">{response.max_applicable_coins || 0}</div>
            </div>
            <div className="text-center">
              <span className="block text-blue-600 text-xs">Remaining Cap</span>
              <div className="font-bold text-blue-800 text-lg">{response.remaining_cap || 0}</div>
            </div>
            <div className="text-center">
              <span className="block text-blue-600 text-xs">Available Entries</span>
              <div className="font-bold text-blue-800 text-lg">{response.applicable_coins?.length || 0}</div>
            </div>
          </div>
          <div className="mt-2 text-center">
            <span className="text-xs text-blue-600">Calculation Method: </span>
            <span className="text-xs font-medium text-blue-800">{response.calculation_method}</span>
          </div>
        </div>

        {/* Applicable Coins List */}
        {response.applicable_coins && response.applicable_coins.length > 0 ? (
          <div className="space-y-3">
            <h4 className="font-semibold text-gray-800 flex items-center">
              <FontAwesomeIcon icon={faCoins} className="mr-2 text-yellow-500" />
              Available Coin Entries ({response.applicable_coins.length})
            </h4>
            {response.applicable_coins.map((coin, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start mb-3">
                  <div className="flex-1">
                    <div className="flex items-center mb-2">
                      <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium mr-2">
                        {coin.usable_coins} Coins Available
                      </span>
                      <span className="text-xs text-gray-500">
                        Created: {new Date(coin.created_at).toLocaleDateString()}
                      </span>
                    </div>
                    
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                      <div>
                        <span className="text-gray-600 block text-xs">Usable Coins</span>
                        <div className="font-bold text-green-600 text-lg">{coin.usable_coins}</div>
                      </div>
                      <div>
                        <span className="text-gray-600 block text-xs">Total Coins</span>
                        <div className="font-medium text-gray-800">{coin.total_coins}</div>
                      </div>
                      <div>
                        <span className="text-gray-600 block text-xs">Max Redeemable</span>
                        <div className="font-medium text-gray-800">{coin.max_redeemable_coins}</div>
                      </div>
                      <div>
                        <span className="text-gray-600 block text-xs">Partner ID</span>
                        <div className="font-medium text-gray-800 text-xs break-all">{coin.partner_id}</div>
                      </div>
                    </div>
                  </div>
                  
                  <button
                    onClick={() => handleApplyRule({
                      ledger_id: coin.ledger_id,
                      eligibility_id: coin.eligibility_id,
                      usable_coins: coin.usable_coins,
                      partner_id: coin.partner_id,
                      total_coins: coin.total_coins,
                      max_redeemable_coins: coin.max_redeemable_coins
                    })}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center"
                  >
                    <FontAwesomeIcon icon={faCheck} className="mr-2" />
                    Use {coin.usable_coins} Coins
                  </button>
                </div>

                {/* Eligibility Details */}
                {coin.eligibility_details && (
                  <div className="border-t border-gray-100 pt-3 mt-3">
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faGift} className="mr-2 text-purple-500 text-sm" />
                      <span className="font-medium text-gray-700 text-sm">Eligibility Details</span>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-xs">
                      <div>
                        <span className="text-gray-500">Eligibility ID:</span>
                        <div className="font-mono text-gray-700 break-all">{coin.eligibility_details.id}</div>
                      </div>
                      <div>
                        <span className="text-gray-500">Eligible BuildCoins:</span>
                        <div className="font-medium text-gray-700">{coin.eligibility_details.eligible_buildcoins}</div>
                      </div>
                      <div>
                        <span className="text-gray-500">Ledger ID:</span>
                        <div className="font-mono text-gray-700 break-all">{coin.ledger_id}</div>
                      </div>
                    </div>

                    {/* Expiry Information */}
                    {coin.eligibility_details.expiry && coin.eligibility_details.expiry.length > 0 && (
                      <div className="mt-2">
                        <span className="text-gray-500 text-xs">Expiry Rules:</span>
                        <div className="flex flex-wrap gap-1 mt-1">
                          {coin.eligibility_details.expiry.map((exp, expIndex) => (
                            <span key={expIndex} className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-xs">
                              {exp.value} {exp.type}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Redemption Caps */}
                    {coin.eligibility_details.redemption_caps && coin.eligibility_details.redemption_caps.length > 0 && (
                      <div className="mt-2">
                        <span className="text-gray-500 text-xs">Redemption Caps:</span>
                        <div className="flex flex-wrap gap-1 mt-1">
                          {coin.eligibility_details.redemption_caps.map((cap, capIndex) => (
                            <span key={capIndex} className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                              {cap.redeem.type}: {cap.redeem.value}
                              {cap.redeem.type === 'percentage' ? '%' : ''}
                              {cap.redeem.limit > 0 && ` (limit: ${cap.redeem.limit})`}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <div className="flex items-center">
              <FontAwesomeIcon icon={faCoins} className="mr-2 text-yellow-600" />
              <p className="text-yellow-700">
                {response.message || 'No applicable coins found for the given criteria.'}
              </p>
            </div>
          </div>
        )}

        {/* Debug/Summary Information */}
        {response.summary && (
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
            <div className="flex items-center mb-2">
              <FontAwesomeIcon icon={faCalculator} className="mr-2 text-gray-600" />
              <h4 className="font-semibold text-gray-800">Processing Summary</h4>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3 text-xs">
              <div className="text-center">
                <span className="block text-gray-500">Ledgers Found</span>
                <div className="font-bold text-gray-700">{response.summary.total_ledgers_found}</div>
              </div>
              <div className="text-center">
                <span className="block text-gray-500">Eligibilities Found</span>
                <div className="font-bold text-gray-700">{response.summary.total_eligibilities_found}</div>
              </div>
              <div className="text-center">
                <span className="block text-gray-500">Filtered Eligibilities</span>
                <div className="font-bold text-gray-700">{response.summary.filtered_eligibilities}</div>
              </div>
              <div className="text-center">
                <span className="block text-gray-500">Applicable Ledgers</span>
                <div className="font-bold text-gray-700">{response.summary.applicable_ledgers}</div>
              </div>
              <div className="text-center">
                <span className="block text-gray-500">Final Usable</span>
                <div className="font-bold text-gray-700">{response.summary.final_usable_entries}</div>
              </div>
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex justify-between items-center pt-4 border-t border-gray-200">
          <div className="text-sm text-gray-600">
            Total coins you can use: <span className="font-bold text-green-600">{response.total_usable_coins}</span>
          </div>
          {response.total_usable_coins > 0 && (
            <button
              onClick={() => {
                // Apply all available coins
                const allCoins = {
                  applicable_coins: response.applicable_coins,
                  total_usable_coins: response.total_usable_coins,
                  max_applicable_coins: response.max_applicable_coins
                };
                handleApplyRule(allCoins);
              }}
              className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center"
            >
              <FontAwesomeIcon icon={faGift} className="mr-2" />
              Use All {response.total_usable_coins} Coins
            </button>
          )}
        </div>
      </div>
    )}
  </div>
)}

        </div>
      </div>
    </div>
  );
};

// Apply Coins Component
const ApplyCoinsComponent = ({ customers, partners, categories, items, backendApiUrl, backendApiUrl2, onCategoryChange,selectedRuleData }) => {
  const [formData, setFormData] = useState({
    customerId: '',
    partnerIds: [],
    categoryIds: [],
    selectedItems: [],
    totalAmount: 0,
    ruleId: '',
    coinsToApply: 0,
    isEcommerce: "Yes"
  });
  const [response, setResponse] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [appliedCoinData, setAppliedCoinData] = useState(null);

  // Load data from applicable coins component if available
  useEffect(() => {
    const savedRule = sessionStorage.getItem('selectedApplicableRule');
    const savedFormData = sessionStorage.getItem('applicableCoinsFormData');
    
    if (savedRule && savedFormData) {
      const rule = JSON.parse(savedRule);
      const previousFormData = JSON.parse(savedFormData);
      
      setFormData(prev => ({
        ...prev,
        ...previousFormData,
        ruleId: rule.ruleId,
        coinsToApply: rule.usable_coins || rule.total_usable_coins || 0
      }));

      // Set applied coin data and show success message
      setAppliedCoinData(rule);
      setShowSuccessMessage(true);
      
      // Clear session storage
      sessionStorage.removeItem('selectedApplicableRule');
      sessionStorage.removeItem('applicableCoinsFormData');
    }
  }, []);

  // Add this function to handle category selection change
  const handleCategorySelection = (selectedIds) => {
    setFormData(prev => ({ ...prev, categoryIds: selectedIds }));
    onCategoryChange(selectedIds); // This will trigger items fetch
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const encryptedToken = sessionStorage.getItem('token');
          const token = decryptData(encryptedToken);
      const response = await fetch(`${backendApiUrl2}rewards/apply-buildcoins-from-wallet`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(formData)
      });
      const data = await response.json();
      setResponse(data);
    } catch (error) {
      console.error('Error applying coins:', error);
      setResponse({ error: 'Failed to process request' });
    } finally {
      setSubmitting(false);
    }
  };

  const calculateTotal = () => {
    const total = formData.selectedItems.reduce((sum, item) => {
      return sum + (item.price * item.quantity);
    }, 0);
    setFormData(prev => ({ ...prev, totalAmount: total }));
  };

  useEffect(() => {
    calculateTotal();
  }, [formData.selectedItems]);

  const handleStartNewApplication = () => {
    setShowSuccessMessage(false);
    setAppliedCoinData(null);
    setResponse(null);
    setFormData({
      customerId: '',
      partnerIds: [],
      categoryIds: [],
      selectedItems: [],
      totalAmount: 0,
      ruleId: '',
      coinsToApply: 0,
      isEcommerce: "Yes"
    });
  };

  // If showing success message, render success component
  if (showSuccessMessage && appliedCoinData) {
    return (
      <div className="p-6 mb-20 min-h-full">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg border border-gray-200">
            {/* Success Header */}
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-b border-green-200 p-6">
              <div className="text-center">
                <div className="bg-green-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <FontAwesomeIcon icon={faCheck} className="text-green-600 text-3xl" />
                </div>
                <h2 className="text-2xl font-bold text-green-800 mb-2">
                  Coins Applied Successfully!
                </h2>
                <p className="text-green-700">
                  Your selected coins have been prepared for application
                </p>
              </div>
            </div>

            {/* Applied Coin Details */}
            <div className="p-6">
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-6 mb-6">
                <h3 className="text-lg font-semibold text-blue-800 mb-4 flex items-center">
                  <FontAwesomeIcon icon={faCoins} className="mr-2 text-yellow-500" />
                  Applied Coin Details
                </h3>

                {appliedCoinData.usable_coins ? (
                  // Single coin entry
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <div className="bg-white bg-opacity-60 rounded-lg p-4">
                        <div className="text-center">
                          <span className="text-blue-600 text-sm font-medium">Coins Applied</span>
                          <div className="text-3xl font-bold text-green-600 mt-1">
                            {appliedCoinData.usable_coins}
                          </div>
                        </div>
                      </div>
                      <div className="bg-white bg-opacity-60 rounded-lg p-4">
                        <div className="text-center">
                          <span className="text-blue-600 text-sm font-medium">Total Available</span>
                          <div className="text-xl font-semibold text-blue-800 mt-1">
                            {appliedCoinData.total_coins}
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="space-y-3 text-sm">
                      <div className="bg-white bg-opacity-60 rounded-lg p-3">
                        <span className="text-blue-600 font-medium">Ledger ID:</span>
                        <div className="font-mono text-blue-800 text-xs break-all mt-1">
                          {appliedCoinData.ledger_id}
                        </div>
                      </div>
                      <div className="bg-white bg-opacity-60 rounded-lg p-3">
                        <span className="text-blue-600 font-medium">Eligibility ID:</span>
                        <div className="font-mono text-blue-800 text-xs break-all mt-1">
                          {appliedCoinData.eligibility_id}
                        </div>
                      </div>
                      <div className="bg-white bg-opacity-60 rounded-lg p-3">
                        <span className="text-blue-600 font-medium">Partner ID:</span>
                        <div className="font-mono text-blue-800 text-xs break-all mt-1">
                          {appliedCoinData.partner_id}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  // Multiple coins (Use All scenario)
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-white bg-opacity-60 rounded-lg p-4 text-center">
                      <span className="text-blue-600 text-sm font-medium">Total Coins Applied</span>
                      <div className="text-3xl font-bold text-green-600 mt-1">
                        {appliedCoinData.total_usable_coins}
                      </div>
                    </div>
                    <div className="bg-white bg-opacity-60 rounded-lg p-4 text-center">
                      <span className="text-blue-600 text-sm font-medium">Max Applicable</span>
                      <div className="text-xl font-semibold text-blue-800 mt-1">
                        {appliedCoinData.max_applicable_coins}
                      </div>
                    </div>
                    <div className="bg-white bg-opacity-60 rounded-lg p-4 text-center">
                      <span className="text-blue-600 text-sm font-medium">Coin Entries</span>
                      <div className="text-xl font-semibold text-blue-800 mt-1">
                        {appliedCoinData.applicable_coins?.length || 0}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Success Actions */}
{/*               <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-6">
                <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
                  <div className="flex items-center text-green-700">
                    <FontAwesomeIcon icon={faCheck} className="mr-3 text-green-500 text-xl" />
                    <div>
                      <div className="font-semibold">Application Successful!</div>
                      <div className="text-sm text-green-600">
                        Coins have been prepared for redemption
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex space-x-3">
                    <button
                      onClick={handleStartNewApplication}
                      className="bg-white text-green-700 border border-green-300 px-6 py-3 rounded-lg hover:bg-green-50 transition-colors flex items-center font-medium"
                    >
                      <FontAwesomeIcon icon={faCoins} className="mr-2" />
                      Apply More Coins
                    </button>
                    <button
                      onClick={() => window.print()}
                      className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors flex items-center font-medium"
                    >
                      <FontAwesomeIcon icon={faPlay} className="mr-2" />
                      Print Details
                    </button>
                  </div>
                </div>
              </div> */}

              {/* Additional Information */}
{/*               <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
                <div className="flex items-start">
                  <FontAwesomeIcon icon={faGift} className="text-blue-500 mr-3 mt-1" />
                  <div>
                    <h4 className="font-semibold text-blue-800 mb-2">What's Next?</h4>
                    <ul className="text-blue-700 text-sm space-y-1">
                      <li>• Your coins are now ready for redemption</li>
                      <li>• You can use these coins for future purchases</li>
                      <li>• Check your wallet balance for updated coin count</li>
                      <li>• Apply more coins if needed using the button above</li>
                    </ul>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Regular form rendering when not showing success message
/*   return (
    <div className="p-6 mb-20 min-h-full">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg border border-gray-200">
          <div className="p-6 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              <FontAwesomeIcon icon={faGift} className="mr-2 text-purple-500" />
              Apply Coins
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faUser} className="mr-2" />
                  Select Customer
                </label>
                <select
                  value={formData.customerId}
                  onChange={(e) => setFormData(prev => ({ ...prev, customerId: e.target.value }))}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Choose a customer...</option>
                  {customers.map(customer => (
                    <option key={customer._id} value={customer._id}>
                      {customer.customer_name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faCoins} className="mr-2" />
                  Coins to Apply
                </label>
                <input
                  type="number"
                  value={formData.coinsToApply}
                  onChange={(e) => setFormData(prev => ({ ...prev, coinsToApply: parseInt(e.target.value) || 0 }))}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter coins to apply..."
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faShoppingCart} className="mr-2" />
                  Is Ecommerce
                </label>
                <div className="flex items-center space-x-3">
                  <button
                    type="button"
                    onClick={() => setFormData(prev => ({ 
                      ...prev, 
                      isEcommerce: prev.isEcommerce === "Yes" ? "No" : "Yes"
                    }))}
                    className={`flex items-center space-x-2 px-4 py-3 rounded-lg border transition-colors ${
                      formData.isEcommerce === "Yes"
                        ? 'bg-green-50 border-green-300 text-green-700' 
                        : 'bg-red-50 border-red-300 text-red-700'
                    }`}
                  >
                    <FontAwesomeIcon 
                      icon={formData.isEcommerce === "Yes" ? faToggleOn : faToggleOff} 
                      className={`text-xl ${formData.isEcommerce === "Yes"? 'text-green-600' : 'text-red-600'}`}
                    />
                    <span className="font-medium">
                      {formData.isEcommerce}
                    </span>
                  </button>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faStore} className="mr-2" />
                  Select Partners
                </label>
                <MultiSelectDropdown
                  options={partners}
                  selectedValues={formData.partnerIds}
                  onChange={(selected) => setFormData(prev => ({ ...prev, partnerIds: selected }))}
                  placeholder="Choose partners..."
                  displayKey="name"
                  valueKey="_id"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faTag} className="mr-2" />
                  Select Categories
                </label>
                <MultiSelectDropdown
                  options={categories}
                  selectedValues={formData.categoryIds}
                  onChange={handleCategorySelection}
                  placeholder="Choose categories..."
                  displayKey="product_category_name"
                  valueKey="_id"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FontAwesomeIcon icon={faBox} className="mr-2" />
                  Select Items
                </label>
                <ItemSelector
                  items={items}
                  selectedItems={formData.selectedItems}
                  onChange={(selected) => setFormData(prev => ({ ...prev, selectedItems: selected }))}
                />
              </div>
            </div>

            <div className="mt-6 p-4 bg-gray-50 rounded-lg">
              <div className="flex justify-between items-center">
                <span className="text-lg font-medium text-gray-700">
                  <FontAwesomeIcon icon={faRupeeSign} className="mr-2" />
                  Total Order Amount:
                </span>
                <span className="text-2xl font-bold text-green-600">
                  ₹{formData.totalAmount.toLocaleString()}
                </span>
              </div>
            </div>

            <div className="mt-6">
              <button
                onClick={handleSubmit}
                disabled={submitting || !formData.customerId || formData.coinsToApply <= 0}
                className="w-full bg-purple-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {submitting ? (
                  <>
                    <FontAwesomeIcon icon={faSpinner} className="mr-2 animate-spin" />
                    Processing...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faGift} className="mr-2" />
                    Apply Coins
                  </>
                )}
              </button>
            </div>
          </div>

          {response && (
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Response</h3>
              <div className="bg-gray-50 rounded-lg p-4">
                <pre className="text-sm text-gray-700 whitespace-pre-wrap">
                  {JSON.stringify(response, null, 2)}
                </pre>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  ); */
};

// Multi-Select Dropdown Component with Search, Clear All, and Done buttons
const MultiSelectDropdown = ({ options, selectedValues, onChange, placeholder, displayKey, valueKey }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const handleToggle = (value) => {
    const newSelected = selectedValues.includes(value)
      ? selectedValues.filter(v => v !== value)
      : [...selectedValues, value];
    onChange(newSelected);
  };

  const handleClearAll = () => {
    onChange([]);
  };

  const handleDone = () => {
    setIsOpen(false);
    setSearchTerm(''); // Clear search when closing
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter options based on search term
  const filteredOptions = options.filter(option =>
    option[displayKey].toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getDisplayText = () => {
    if (selectedValues.length === 0) return placeholder;
    if (selectedValues.length === 1) {
      const item = options.find(opt => opt[valueKey] === selectedValues[0]);
      return item ? item[displayKey] : '';
    }
    return `${selectedValues.length} items selected`;
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-left bg-white flex justify-between items-center"
      >
        <span className={selectedValues.length === 0 ? 'text-gray-500' : 'text-gray-900'}>
          {getDisplayText()}
        </span>
        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} className="text-gray-400" />
      </button>

      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-80 overflow-hidden">
          {/* Search Input */}
          <div className="p-3 border-b border-gray-200">
            <div className="relative">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange}
                className="w-full p-2 pl-8 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                onClick={(e) => e.stopPropagation()}
              />
              <FontAwesomeIcon 
                icon={faSearch} 
                className="absolute left-2.5 top-2.5 text-gray-400 text-sm" 
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="p-3 border-b border-gray-200 flex justify-between items-center bg-gray-50">
            <button
              onClick={handleClearAll}
              className="text-sm text-red-600 hover:text-red-800 font-medium flex items-center"
            >
              <FontAwesomeIcon icon={faTimes} className="mr-1 text-xs" />
              Clear All
            </button>
            <div className="text-sm text-gray-600">
              {selectedValues.length} of {options.length} selected
            </div>
            <button
              onClick={handleDone}
              className="text-sm bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 font-medium"
            >
              Done
            </button>
          </div>

          {/* Options List */}
          <div className="max-h-48 overflow-y-auto">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <div
                  key={option[valueKey]}
                  onClick={() => handleToggle(option[valueKey])}
                  className="p-3 hover:bg-gray-50 cursor-pointer flex items-center border-b border-gray-100 last:border-b-0"
                >
                  <input
                    type="checkbox"
                    checked={selectedValues.includes(option[valueKey])}
                    onChange={() => {}}
                    className="mr-3 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                  <span className="text-gray-900 flex-1">{option[displayKey]}</span>
                  {selectedValues.includes(option[valueKey]) && (
                    <FontAwesomeIcon icon={faCheck} className="text-blue-600 text-sm" />
                  )}
                </div>
              ))
            ) : (
              <div className="p-3 text-gray-500 text-center">
                {searchTerm ? `No results found for "${searchTerm}"` : 'No options available'}
              </div>
            )}
          </div>

          {/* Footer with selection count */}
          {filteredOptions.length > 0 && (
            <div className="p-2 bg-gray-50 border-t border-gray-200 text-xs text-gray-600 text-center">
              Showing {filteredOptions.length} of {options.length} options
            </div>
          )}
        </div>
      )}
    </div>
  );
};


// Item Selector Component with Search, Clear All, Done, and Select All
const ItemSelector = ({ items, selectedItems, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const handleItemToggle = (item) => {
    const existingIndex = selectedItems.findIndex(si => si._id === item._id);
    if (existingIndex >= 0) {
      const newSelected = selectedItems.filter(si => si._id !== item._id);
      onChange(newSelected);
    } else {
      const newSelected = [...selectedItems, { ...item, quantity: 1, price: item.selling_price || 0 }];
      onChange(newSelected);
    }
  };

  const handleQuantityChange = (itemId, quantity) => {
    const newSelected = selectedItems.map(item =>
      item._id === itemId ? { ...item, quantity: parseInt(quantity) || 0 } : item
    );
    onChange(newSelected);
  };

  const handlePriceChange = (itemId, price) => {
    const newSelected = selectedItems.map(item =>
      item._id === itemId ? { ...item, price: parseFloat(price) || 0 } : item
    );
    onChange(newSelected);
  };

  const handleClearAll = () => {
    onChange([]);
  };

  const handleSelectAll = () => {
    const newItems = filteredItems
      .filter(item => !selectedItems.some(si => si._id === item._id))
      .map(item => ({ ...item, quantity: 1, price: item.selling_price || 0 }));
    
    onChange([...selectedItems, ...newItems]);
  };

  const handleDone = () => {
    setIsOpen(false);
    setSearchTerm('');
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter items based on search term
  const filteredItems = items.filter(item =>
    item.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const isAllFilteredSelected = filteredItems.length > 0 && 
    filteredItems.every(item => selectedItems.some(si => si._id === item._id));

  const getDisplayText = () => {
    if (selectedItems.length === 0) return 'Select items...';
    if (selectedItems.length === 1) return selectedItems[0].product_name || selectedItems[0].name;
    return `${selectedItems.length} items selected`;
  };

  return (
    <div className="space-y-4">
      {/* Dropdown for selecting items */}
      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-left bg-white flex justify-between items-center"
        >
          <span className={selectedItems.length === 0 ? 'text-gray-500' : 'text-gray-900'}>
            {getDisplayText()}
          </span>
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} className="text-gray-400" />
        </button>

        {isOpen && (
          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-96 overflow-hidden">
            {/* Search Input */}
            <div className="p-3 border-b border-gray-200">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search items..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="w-full p-2 pl-8 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  onClick={(e) => e.stopPropagation()}
                />
                <FontAwesomeIcon 
                  icon={faSearch} 
                  className="absolute left-2.5 top-2.5 text-gray-400 text-sm" 
                />
              </div>
            </div>

            {/* Action Buttons */}
            <div className="p-3 border-b border-gray-200 bg-gray-50">
              <div className="flex justify-between items-center mb-2">
                <div className="flex space-x-2">
                  <button
                    onClick={handleSelectAll}
                    disabled={isAllFilteredSelected || filteredItems.length === 0}
                    className="text-xs text-blue-600 hover:text-blue-800 font-medium disabled:text-gray-400 disabled:cursor-not-allowed flex items-center"
                  >
                    <FontAwesomeIcon icon={faCheck} className="mr-1 text-xs" />
                    Select All
                  </button>
                  <span className="text-gray-300">|</span>
                  <button
                    onClick={handleClearAll}
                    disabled={selectedItems.length === 0}
                    className="text-xs text-red-600 hover:text-red-800 font-medium disabled:text-gray-400 disabled:cursor-not-allowed flex items-center"
                  >
                    <FontAwesomeIcon icon={faTimes} className="mr-1 text-xs" />
                    Clear All
                  </button>
                </div>
                <button
                  onClick={handleDone}
                  className="text-xs bg-blue-600 text-white px-3 py-1.5 rounded hover:bg-blue-700 font-medium transition-colors"
                >
                  Done
                </button>
              </div>
              <div className="text-xs text-gray-600 text-center">
                {selectedItems.length} of {items.length} selected
                {searchTerm && ` • Showing ${filteredItems.length} results`}
              </div>
            </div>

            {/* Items List */}
            <div className="max-h-52 overflow-y-auto">
              {filteredItems.length > 0 ? (
                filteredItems.map((item) => (
                  <div
                    key={item._id}
                    onClick={() => handleItemToggle(item)}
                    className={`p-3 hover:bg-blue-50 cursor-pointer flex items-center border-b border-gray-100 last:border-b-0 transition-colors ${
                      selectedItems.some(si => si._id === item._id) ? 'bg-blue-25' : ''
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={selectedItems.some(si => si._id === item._id)}
                      onChange={() => {}}
                      className="mr-3 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                    <div className="flex-1">
                      <span className="text-gray-900 font-medium text-sm">
                        {item.product_name || item.name}
                      </span>
                      <div className="text-xs text-gray-500 mt-1">
                        Price: ₹{item.selling_price || item.price || 0}
                        {item.category && ` • Category: ${item.category}`}
                      </div>
                    </div>
                    {selectedItems.some(si => si._id === item._id) && (
                      <FontAwesomeIcon icon={faCheck} className="text-blue-600 text-sm ml-2" />
                    )}
                  </div>
                ))
              ) : (
                <div className="p-6 text-gray-500 text-center">
                  <FontAwesomeIcon icon={faSearch} className="text-2xl text-gray-300 mb-2" />
                  <div className="text-sm">
                    {searchTerm ? (
                      <>
                        No items found for <strong>"{searchTerm}"</strong>
                        <br />
                        <button
                          onClick={() => setSearchTerm('')}
                          className="text-blue-600 hover:text-blue-800 text-xs mt-1"
                        >
                          Clear search
                        </button>
                      </>
                    ) : (
                      'No items available'
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Selected items with quantity and price inputs */}
      {selectedItems.length > 0 && (
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <h4 className="font-medium text-gray-700">Selected Items:</h4>
            <div className="flex space-x-2">
              <span className="text-sm text-gray-500">
                {selectedItems.length} item{selectedItems.length !== 1 ? 's' : ''} selected
              </span>
              <button
                onClick={handleClearAll}
                className="text-xs text-red-600 hover:text-red-800 font-medium"
              >
                Clear All
              </button>
            </div>
          </div>
          
          {selectedItems.map((item) => (
            <div key={item._id} className="bg-gray-50 p-4 rounded-lg border border-gray-200">
              <div className="flex items-center justify-between mb-3">
                <div className="flex-1">
                  <h5 className="font-medium text-gray-800">
                    {item.product_name || item.name}
                  </h5>
                  <p className="text-sm text-gray-600">
                    Base Price: ₹{item.selling_price || item.price || 0}
                  </p>
                </div>
                <button
                  onClick={() => handleItemToggle(item)}
                  className="text-red-500 hover:text-red-700 p-2 hover:bg-red-50 rounded-full transition-colors"
                  title="Remove item"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    <FontAwesomeIcon icon={faHashtag} className="mr-1" />
                    Quantity
                  </label>
                  <input
                    type="number"
                    min="1"
                    value={item.quantity}
                    onChange={(e) => handleQuantityChange(item._id, e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  />
                </div>
                
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    <FontAwesomeIcon icon={faDollarSign} className="mr-1" />
                    Unit Price (₹)
                  </label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={item.price}
                    onChange={(e) => handlePriceChange(item._id, e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  />
                </div>
                
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    <FontAwesomeIcon icon={faRupeeSign} className="mr-1" />
                    Total Amount (₹)
                  </label>
                  <div className="w-full p-2 bg-gray-100 border border-gray-300 rounded text-gray-700 font-medium text-sm">
                    ₹{(item.quantity * item.price).toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
          ))}
          
          {/* Summary */}
          <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
            <div className="flex justify-between items-center text-sm">
              <span className="font-medium text-blue-800">
                Total Items: {selectedItems.reduce((sum, item) => sum + item.quantity, 0)}
              </span>
              <span className="font-bold text-blue-900">
                Grand Total: ₹{selectedItems.reduce((sum, item) => sum + (item.quantity * item.price), 0).toLocaleString()}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


export default RewardRulesSimulator;
